import React, { ChangeEvent } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import FloatingLabelDatepicker from "../../../../common/DatePicker";
import { useEffect, useRef, useState } from "react";
import TimePicker from "../../../../common/TimePicker";
import TextInput from "../../../../common/TextInput";
import {
  APPOINTMENT_ACTIONS,
  APPOINTMENT_TAB_ACTIONS,
} from "../../../../common/EventConstant";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import {
  EDITOR_REPORT_STATUS,
  HISTORY_REPORT_STATUS,
  PICKLIST_GROUP_NAME,
  QME_APPOINTMENT_SCHEDULE_CATEGORY,
  QME_APPOINTMENT_STATUS,
  ROR_STATUS,
  TRANSCRIPTION_REPORT_STATUS,
  WEB_ROLE,
} from "../../../../common/Constant";
import { handleGeneratePDF } from "../../Case_Records/components/110Pdf";
import {
  addQMEScheduleDetails,
  fetchCancelAppointment,
  fetchCancelAppointmentreason,
  fetchInjuryListDetails,
  fetchInterpreterListDetails,
  fetchPickListByGroupName,
  fetchQMEDoctorContacts,
  fetchVendorList,
  fetcQMEDoctorHospitalList,
  fetcQMEDoctorList,
  getQMEProcessStatus,
  getQMEScheduleDetails,
  updateQMEScheduleDetails,
  validateDoctorAppointment,
} from "../../../../services/ScheduleAppointmentApi";
import { validateScheduleAppointment } from "../actions/ScheduleAppointmentValidation";
import Snackbar from "../../../../common/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/Store";
import EmployerDetailsCard from "../../Case_Subject/components/EmployeeDetailsCard";
import {
  GetDoctorDetails,
  GetMedicalAssistant,
  searchHospitalClinic,
  searchManualZipCode,
  searchZipCode,
} from "../../../../services/StakeholderApi";
import TagComponent from "../../../../common/TagComponent";
import { formatDateTime } from "../../../../utils/dateUtils";
import moment from "moment";
import Loader from "../../../../common/Loader";
import { useHref, useNavigate } from "react-router-dom";
import AccordionComponent from "../../../../common/Accordion";
import EndTimePicker from "../../../../common/EndTimePicker";
import { fetchCaseStages } from "../../../../redux/slice/caseStagesSlice";
import {
  setClientId,
  setIsViewSchedule,
  setQMEScheduleAvailable,
} from "../../../../redux/slice/CaseHeaderSlice";
import { useIsStageReadOnly } from "../../../../utils/caseStageChecker";
import { fetchCaseheaderinfo } from "../../../../services/CaseInformationApi";
import SearchableAddressDropdown from "../../../../common/SearchableZipDropdown";
import { isValidCoordinate } from "../../../../utils/validators";
import AppointmentActionsDropdown from "../../../../common/AppointmentActionsDropdown";
import { addMedicareLocation } from "../../../../services/SystemLocationAPI";
import SearchHospitalAutosuggest, { LocationSuggestion } from "../../../../common/SearchHospitalAutosuggest";
import { AppointmentBulkUpdateStatus } from "../../../../services/AppointmentListApi";
import {
  downloadQMEFormsZip,
  getDoctorNextAvailability,
  RequestForRescheduleAppointment,
  downloadSIBTFForm,
  getAppointmentActionsAccessList,
} from "../../../../services/AppointmentsAPI";
import { fetcheaderinfo } from "../../../../services/UserRegistrationApi";
import { useFeatureAccess } from "../../../../hooks/useFeatureAccess";
import { getHistorianDetailsByQMEID } from "../../../../services/HistorianAPI";
import DataTable from "../../../../common/DataTable";
import {
  QME_EDITOR_HEADERS,
  QME_HISTORIAN_HEADERS,
  TRANSC_EDITOR_HEADERS,
} from "../actions/constant";
import DateRangePicker from "../../../../common/CustomDateRangePicker";
import { normalizeCountry, normalizeState } from "../../../../utils/normalizer";
import SearchAutosuggest from "../../../../common/SearchAutosuggestLocations";
import SearchableMultiSelectDropdown from "../../../../common/SearchableMultiSelectDropdown";
import TextWithTooltip from "../../../../common/TextWithTooltip";
import { GetReviewerRORStatusUpdateList } from "../../../../services/RecordReviewerAPI";
import { REVIEW_HISTORY_HEADERS } from "../../../ToDos/RecordReviewer/actions/constants";
import { getEditorDetailsByQMEID } from "../../../../services/EditorWorkFlowAPI";
import { getTranscriberStatusLogsList } from "../../../../services/TranscriberAPI";
import HistorianActionDrawer from "../../../ToDos/Historian/components/HistoriansActionDrawer";
import ViewQMESchedule from "./View_QME_Schedule";
import ViewScheduleDrawer from "./ViewScheduleDrawer";
import { getPlaceByAddress } from "../../../../utils/getPlaceByAddress";

interface ScheduleAppointmentProps {
  userData: any;
  action: string;
  loggedInUserid: any;
  caseStageId: any;
  onCancel: (action: string) => void;
  selectedRowData: any;
  onTabChange: any;
  qmeActiveTab: any;
  isRowActionTriggered: boolean;
  activeTab: any;
  setSelectedRowData: any;
}

interface Option {
  areaName?: string;
  localeName?: string;
  physicalCity?: string;
  physicalZip?: string;
  physicalState?: string;
  districtName?: string;
  medicareId?: string;
  providerName?: string;
  providerAddress?: string;
  countryName?: string;
}

interface OptionFprInterpreter {
  interpreterName?: string;
  interpreterPhoneNumber?: string;
  interpreterCertificateNumber?: string;
}

interface HospitalClinicSearchResult {
  areaName: string;
  districtName: string;
  localeName: string;
  physicalCity: string;
  physicalState: string;
  physicalZip: string;
  country: string;
}

interface ActionOption {
  value: string;
  label: string;
}

type DoctorInfo = {
  id: string | number;
  name: string;
  appointmentDate: Date | null;
};

const formattedDateTime = (date: string | Date): string | null => {
  if (!date) {
    console.error("Invalid input: date is required.");
    return null;
  }

  // Format date as "YYYY-MM-DD" and append "T00:00:00"
  const formattedDate = moment(date).format("YYYY-MM-DD");
  return `${formattedDate}T00:00:00`;
};

const extractSpecialization = (name: string): string | null => {
  const parts = name?.split("(");
  if (parts?.length > 1) {
    return parts[1].replace(")", "")?.trim();
  }
  return null;
};

const DISABLED_STATUSES = [
  QME_APPOINTMENT_STATUS.CANCELLED,
  QME_APPOINTMENT_STATUS.PATIENT_NO_SHOW,
  QME_APPOINTMENT_STATUS.QME_NO_SHOW,
  QME_APPOINTMENT_STATUS.COMPLETED,
  QME_APPOINTMENT_STATUS.CANCELLED_PATIENT_NO_SHOW,
  QME_APPOINTMENT_STATUS.CANCELLED_INTERPRETER_NO_SHOW,
  QME_APPOINTMENT_STATUS.CANCELLED_QME_NO_SHOW,
  QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE,
  QME_APPOINTMENT_STATUS.INTERPRETER_NO_SHOW,
];

const DISABLED_STATUSES_CASEMANAGER = [
  QME_APPOINTMENT_STATUS.CANCELLED,
  QME_APPOINTMENT_STATUS.PATIENT_NO_SHOW,
  QME_APPOINTMENT_STATUS.QME_NO_SHOW,
  QME_APPOINTMENT_STATUS.COMPLETED,
  QME_APPOINTMENT_STATUS.CANCELLED_PATIENT_NO_SHOW,
  QME_APPOINTMENT_STATUS.CANCELLED_INTERPRETER_NO_SHOW,
  QME_APPOINTMENT_STATUS.CANCELLED_QME_NO_SHOW,
  QME_APPOINTMENT_STATUS.INTERPRETER_NO_SHOW,
];

// Map labels to feature access keys
const actionOptionFeatureMap: Record<string, string> = {
  "Patient No Show": APPOINTMENT_ACTIONS.PATIENT_NO_SHOW,
  "Interpreter No Show": APPOINTMENT_ACTIONS.INTERPRETER_NO_SHOW,
  "QME Doctor No Show": APPOINTMENT_ACTIONS.QME_DOCTOR_NO_SHOW,
  "Patient Checked In": APPOINTMENT_ACTIONS.PATIENT_CHECKIN,
  "Reschedule Request": APPOINTMENT_TAB_ACTIONS.RESCHEDULE,
  Cancel: APPOINTMENT_ACTIONS.CANCEL,
  "Generate 110/SIBTF Form": APPOINTMENT_ACTIONS.GENERATE_110_POS_SIBTF_FORM,
  "View QME Schedule": APPOINTMENT_ACTIONS.VIEW_QME_SCHEDULE,
  "Doctors Location Map": APPOINTMENT_ACTIONS.DOCTOR_LOCATION_MAP,
  Complete: APPOINTMENT_TAB_ACTIONS.COMPLETED,
};

const allOptions = {
  reschedule: {
    value: QME_APPOINTMENT_STATUS.RESCHEDULED,
    label: "Reschedule",
  },
  reschedule_request: {
    value: QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE,
    label: "Reschedule Request",
  },
  checkin: {
    value: QME_APPOINTMENT_STATUS.PATIENT_CHECKED_IN,
    label: "Patient Checkin",
  },
  patientNoShow: {
    value: QME_APPOINTMENT_STATUS.PATIENT_NO_SHOW,
    label: "Patient No Show",
  },
  interpreterNoShow: {
    value: QME_APPOINTMENT_STATUS.INTERPRETER_NO_SHOW,
    label: "Interpreter No Show",
  },
  doctorNoShow: {
    value: QME_APPOINTMENT_STATUS.QME_NO_SHOW,
    label: "QME Doctor No Show",
  },
  cancel: { value: QME_APPOINTMENT_STATUS.CANCELLED, label: "Cancel" },
  complete: { value: QME_APPOINTMENT_STATUS.COMPLETED, label: "Complete" },
};

const ScheduleAppointment: React.FC<ScheduleAppointmentProps> = ({
  userData,
  action,
  loggedInUserid,
  caseStageId,
  onCancel,
  selectedRowData,
  onTabChange,
  qmeActiveTab,
  isRowActionTriggered,
  activeTab,
  setSelectedRowData,
}) => {
  const params = {
    appointmentType: {
      groupName: PICKLIST_GROUP_NAME.Appointment_Type,
      triggerById: loggedInUserid,
    },
    appointmentCategory: {
      groupName: PICKLIST_GROUP_NAME.Appointment_Category,
      triggerById: loggedInUserid,
    },
    appointmentStatus: {
      groupName: PICKLIST_GROUP_NAME.Appointment_Status,
      triggerById: loggedInUserid,
    },
    conductMedicalExam: {
      groupName: PICKLIST_GROUP_NAME.Conduct_Medical_Exam,
      triggerById: loggedInUserid,
    },
    interpreterLanguage: {
      groupName: PICKLIST_GROUP_NAME.Interpreter_Language,
      triggerById: loggedInUserid,
    },
    location: {
      groupName: PICKLIST_GROUP_NAME.Location_SplInstructions,
      triggerById: loggedInUserid,
    },
  };

  const dispatchNew = useDispatch<AppDispatch>();
  const { view_Case } = useSelector((state: RootState) => state.featureAccess);
  const { filterByAccess } = useFeatureAccess();
  const isStageNonEditable = useIsStageReadOnly();
  const selectedTime = selectedRowData?.endTime
    ? moment(selectedRowData.endTime).format("HH:mm")
    : null;
  const selectedTimeCheck = selectedRowData?.startTime
    ? moment(selectedRowData.startTime).format("HH:mm")
    : null;
  const currentTime = moment(new Date()).format("HH:mm");
  const isCurrentTimeGreater = selectedTime
    ? currentTime > selectedTime
    : false;
  const isCurrentTimeGreaterThanStart = selectedTimeCheck
    ? currentTime >= selectedTimeCheck
    : false;
  const currentendTimeNew = moment().add(1, "minutes").format("HH:mm");
  const [loading, setLoading] = useState(false);
  const { caseInfoId, client_stakeholderId, isQMEScheduleAvailable } =
    useSelector((state: RootState) => state.caseHeader);
  const { caseSubjectId } = useSelector(
    (state: RootState) => state.caseSubject,
  );

  const isEditable = action !== "View";

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [dateOfAppointment, setDateOfAppointment] = useState<Date | null>(
    new Date(),
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [reasonError, setReasonError] = useState(false);

  const [startTime, setStartTime] = useState<any>(currentTime);
  const [endTime, setEndTime] = useState<any>(currentendTimeNew);
  const [duration, setDuration] = useState<string | null | number>(null);
  const [appointmentType, setAppointmentType] = useState<
    string | null | number
  >(null);
  const [appointmentTypeOptions, setAppointmentTypeOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [QMEDoctor, setQMEDoctor] = useState<string | null | number>(null);
  const [QMEDoctorOptions, setQMEDoctorOptions] = useState<
    {
      value: string;
      label: string;
      specialization: string;
      contactFullName: string;
    }[]
  >([]);
  const [specialization, setSpecialization] = useState<string | null | number>(
    "",
  );
  const [medicalAssistance, setMedicalAssistance] = useState<
    string | null | number
  >(null);
  const [medicalAssistanceOptions, setMedicalAssistanceOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [experience, setExperience] = useState<string | null | number>("");
  const [appointmentNumber, setAppointmentNumber] = useState<
    string | null | number
  >("");
  const [appointmentStatus, setAppointmentStatus] = useState<
    string | null | number
  >(null);
  const [appointmentStatusOptions, setAppointmentStatusOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [appointmentCategory, setAppointmentCategory] = useState<
    string | null | number
  >(null);
  const [appointmentCategoryOptions, setAppointmentCategoryOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const [medicalExamOptions, setMedicalExamOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [ismedicalExam, setIsMedicalExam] = useState<string | null>(null);
  const [reasonForVisit, setReasonForVisit] = useState<string | null | number>(
    "",
  );
  const [isTransportation, setIsTransportation] = useState<boolean>(false);
  const [isUpcommingOrlaterStatus, setIsUpcommingOrlaterStatus] =
    useState<boolean>(false);
  const [specifyNeeds, setSpecifyNeeds] = useState<string>("");
  const [isInterpreterReq, setIsInterpreterReq] = useState<boolean>(false);
  const [languageNeed, setLanguageNeed] = useState<string | null | number>(
    null,
  );
  const [languageNeedLabel, setLanguageNeedLabel] = useState<string>("");
  const [languageNeedOptions, setLanguageNeedOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [vendor, setVendor] = useState<string | null | number>(null);
  const [vendorOptions, setVendorOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [clinicDetails, setClinicDetails] = useState<any[]>([]);
  const [clinicId, setClinicId] = useState<string | null | number>(null);
  const [medicalExamValue, setMedicalExamValue] = useState<any>(null);
  const [result, setResult] = useState<any>({});
  const [clientResult, setClientResult] = useState({
    employerName: "",
    employerAddress: "",
    employerCity: "",
    employerState: "",
    employerZipcode: "",
    employerCountry: "",
    employerContact: "",
    empcontactemailaddress: "",
    empcontactphonenumber: "",
    empcontactfaxnumber: "",
  });
  const [phoneNumber, setPhoneNumber] = useState<string[]>([]);
  const [emailAddress, setEmailAddress] = useState<string[]>([]);
  const [faxNumber, setFaxNumber] = useState<string[]>([]);
  const [showAddClinic, setShowAddClinic] = useState(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [suggestionSelected, setSuggestionSelected] = useState(false);
  const [suggestionFilled, setSuggestionFilled] = useState({ city: false, state: false, country: false, zip: false });
  const [selectedOptionNew, setSelectedOptionNew] = useState<Option | null>(
    null,
  );
  const [addressDetails, setAddressDetails] = useState({
    city: "",
    state: "",
    country: "",
    zip: "",
    medicareId: "",
    providerName: "",
    providerAddress: "",
  });
  const dropdownRef = useRef<HTMLDivElement>(null);
  const dropdownRefNew = useRef<HTMLDivElement>(null);
  const datePickerRef = useRef<HTMLDivElement>(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalNew, setShowModalNew] = useState(false);
  const [showModalForAction, setShowModalForAction] = useState(false);
  const [isValidateDate, setIsValidateDate] = useState(false);
  const [isStartTimeChange, setisStartTimeChange] = useState(false);
  const [baseAppointmentTypeData, setBaseAppointmentTypeData] = useState<any[]>(
    [],
  );
  const [baseAppointmentCategoryData, setBaseAppointmentCategoryData] =
    useState<any[]>([]);
  const [baseAppointmentStatusData, setBaseAppointmentStatusData] = useState<
    any[]
  >([]);
  const [baseInterpreterLanguageData, setBaseInterpreterLanguageData] =
    useState<any[]>([]);
  const [baseVendorData, setBaseVendorData] = useState<any[]>([]);

  const [dropdownOpenForInterpreter, setDropdownOpenForInterpreter] =
    useState(false);
  const [searchQueryForInterpreter, setSearchQueryForInterpreter] =
    useState<string>("");
  const [filteredResultsForInterpreter, setFilteredResultsForInterpreter] =
    useState<OptionFprInterpreter[]>([]);
  const [interpreterDetails, setInterpreterDetails] = useState<any[]>([]);
  const [selectedOptionForInterpreter, setSelectedOptionForInterpreter] =
    useState<any>(null);
  const [showAddInterpreter, setShowAddInterpreter] = useState(false);
  const [interpreterDetailsName, setInterpreterDetailsName] =
    useState<string>("");
  const [interpreterDetailsPhoneNo, setInterpreterDetailsPhoneNo] = useState<
    string[]
  >([]);
  const [interpreterDetailsCertiNo, setInterpreterDetailsCertiNo] =
    useState<string>("");
  const [injuryOptions, setInjuryOptions] = useState<
    {
      value: string;
      label: string;
      claimNo: string;
      dateOfIncident: string;
      insuranceCarrier: string;
      injuryType: string;
    }[]
  >([]);
  const [injury, setInjury] = useState<string[]>([]);
  const [injuryDetails, setInjuryDetails] = useState({
    claimNo: "",
    dateOfIncident: "",
    insuranceCarrier: "",
  });

  const [isshowInterpreter, setIsShowInterpreter] = useState<boolean>(false);
  const [QMEDoctorReset, setQMEDoctorReset] = useState<string | null | number>(
    null,
  );
  const [injuryReset, setInjuryReset] = useState<string[]>([]);

  const [isManualEntry, setIsManualEntry] = useState(false);
  const [manualLocation, setManualLocation] = useState("");
  const [manualAddress, setManualAddress] = useState("");
  const [manualCity, setManualCity] = useState("");
  const [manualState, setManualState] = useState("");
  const [manualCountry, setManualCountry] = useState("");
  const [manualZip, setManualZip] = useState("");

  const [cityOptions, setCityOptions] = useState<string[]>([]);
  const [stateOptions, setStateOptions] = useState<string[]>([]);
  const [countryOptions, setCountryOptions] = useState<string[]>([]);
  const [zipOptions, setZipOptions] = useState<string[]>([]);
  const [selectedAction, setSelectedAction] = useState<string | number>("");
  const [selectedActionlabel, setSelectedActionlabel] = useState<
    string | number
  >("");
  const [reasonForAction, setReasonForAction] = useState<string>("");
  const [dateForAction, setDateForAction] = useState<Date | null>(new Date());
  const [startTimeForAction, setStartTimeForAction] =
    useState<any>(currentTime);
  const [locationForAction, setLocationForAction] = useState<String>("");
  const [userRole, setUserRole] = useState("");
  const [mediacreLocation, setMedicareLocation] = useState("");
  const [historianKey, setHistorianKey] = useState<string | null>(null);
  const [editorKey, setEditorKey] = useState<string | null>(null);
  const [transciberKey, setTransciberKey] = useState<string | null>(null);
  const [recordReviewerKey, setRecordReviwerKey] = useState<string | null>(
    null,
  );
  const CaseTypeName = useSelector(
    (state: RootState) => state.caseHeader.CaseTypeName,
  );

  const [instructionOption, setInstructionOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [isManualLocation, setIsManualLocation] = useState(false);
  const [pendingGoogleLocation, setPendingGoogleLocation] = useState<any>(null);

  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures,
  );
  const [filteredActionOptionsNew, setFilteredActionOptionsNew] = useState<
    any[]
  >([]);
  const is110Download = allowedFeatures.has(
    APPOINTMENT_ACTIONS.GENERATE_110_POS_SIBTF_FORM,
  );
  const [showViewScheduleDrawer, setShowViewScheduleDrawer] = useState(false);
  const [showViewScheduleSubmit, setShowViewScheduleSubmit] = useState(false);
  const [selectedDoctorInfo, setSelectedDoctorInfo] =
    useState<DoctorInfo | null>(null);

  const navigate = useNavigate();
  const ensureOptionsContainSelection = (
    QMEScheduleData: any,
    optionsData: {
      appointmentTypeData: any[];
      appointmentCategoryData: any[];
      appointmentStatusData: any[];
      interpreterLanguageData: any[];
      vendorData: any[];
    },
  ) => {
    const updates = {
      appointmentType: {
        options: [...(optionsData.appointmentTypeData || [])],
        id: QMEScheduleData?.appointmentTypeId,
        desc: QMEScheduleData?.appointmentTypeDesc,
        setter: setAppointmentTypeOptions,
      },
      appointmentCategory: {
        options: [...(optionsData.appointmentCategoryData || [])],
        id: QMEScheduleData?.appointmentCategoryId,
        desc: QMEScheduleData?.appointmentCategoryDesc,
        setter: setAppointmentCategoryOptions,
      },
      appointmentStatus: {
        options: [...(optionsData.appointmentStatusData || [])],
        id: QMEScheduleData?.appointmentStatusId,
        desc: QMEScheduleData?.appointmentStatusDesc,
        setter: setAppointmentStatusOptions,
      },
      languageNeed: {
        options: [...(optionsData.interpreterLanguageData || [])],
        id: QMEScheduleData?.interpreterLanguageId,
        desc: QMEScheduleData?.interpreterLanguageDesc,
        setter: setLanguageNeedOptions,
      },
      vendor: {
        options: [...(optionsData.vendorData || [])],
        id: QMEScheduleData?.interpreterVendorId,
        desc: QMEScheduleData?.interpreterVendorDesc,
        setter: setVendorOptions,
      },
    };

    Object.entries(updates).forEach(([_, { options, id, desc, setter }]) => {
      if (id && desc && !options.some((opt: any) => opt.value === id)) {
        const newOptions = [...options, { value: id, label: desc }];
        setter(removeDuplicates(newOptions));
      }
    });
  };

  const removeDuplicates = (options: any[]) => {
    return Array.from(
      new Map(options.map((item) => [item.value, item])).values(),
    );
  };

  const safeApiCall = async (
    apiCall: Promise<any>,
    onSuccess: (data: any) => void,
  ) => {
    try {
      const res = await apiCall;
      onSuccess(res);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      safeApiCall(fetchPickListByGroupName(params.appointmentType), (res) => {
        setBaseAppointmentTypeData(res || []);
        setAppointmentTypeOptions(res || []);
      });

      safeApiCall(
        fetchPickListByGroupName(params.appointmentCategory),
        (res) => {
          setBaseAppointmentCategoryData(res || []);
          setAppointmentCategoryOptions(res || []);
        },
      );

      safeApiCall(fetchPickListByGroupName(params.appointmentStatus), (res) => {
        setBaseAppointmentStatusData(res || []);
        setAppointmentStatusOptions(res || []);
      });

      safeApiCall(
        fetchPickListByGroupName(params.conductMedicalExam),
        (res) => {
          setMedicalExamOptions(res || []);
        },
      );

      safeApiCall(
        fetchPickListByGroupName(params.interpreterLanguage),
        (res) => {
          setBaseInterpreterLanguageData(res || []);
          setLanguageNeedOptions(res || []);
        },
      );

      safeApiCall(fetchVendorList(), (res) => {
        setBaseVendorData(res || []);
        setVendorOptions(res || []);
      });

      safeApiCall(fetchQMEDoctorContacts(loggedInUserid), (res) => {
        setQMEDoctorOptions(res || []);
      });

      safeApiCall(fetchInjuryListDetails(caseInfoId), (res) => {
        setInjuryOptions(res || []);

        const selectedPrimary = res?.find(
          (item: any) => item.isPrimaryInjury === 1,
        );

        if (!selectedRowData?.subjectQmeScheduleId) {
          setInjury([selectedPrimary?.value || res?.[0]?.value]);
          setInjuryReset([selectedPrimary?.value || res?.[0]?.value]);
        }
      });

      safeApiCall(fetchCaseheaderinfo(caseInfoId), (res) => {
        const doctorId = res?.qmeDoctorContactId ?? null;
        setQMEDoctor(doctorId);
        setQMEDoctorReset(doctorId);
        fetchHospitalList(doctorId);
      });

      safeApiCall(GetMedicalAssistant(caseInfoId), (res) => {
        const medicareAssistanceData = res?.result?.map((item: any) => ({
          value: item.userId,
          label: item.medicalAssistantNames,
        }));
        setMedicalAssistanceOptions(medicareAssistanceData || []);
      });

      safeApiCall(fetcheaderinfo(loggedInUserid), (res) => {
        setUserRole(res?.currentAppRoleDesc || "");
      });

      safeApiCall(fetchPickListByGroupName(params.location), (res) => {
        setInstructionOption(res || []);
      });

      if (selectedRowData?.subjectQmeScheduleId) {
        const QMEScheduleData = await getQMEScheduleDetails(
          selectedRowData.subjectQmeScheduleId,
        );

        if (!QMEScheduleData) return;

        // ensureOptionsContainSelection(QMEScheduleData, {
        //   appointmentTypeData: baseAppointmentTypeData,
        //   appointmentCategoryData: baseAppointmentCategoryData,
        //   appointmentStatusData: baseAppointmentStatusData,
        //   interpreterLanguageData: baseInterpreterLanguageData,
        //   vendorData: baseVendorData,
        // });

        await fetchHospitalList(QMEScheduleData?.qmeDoctorContactId);

        setDateOfAppointment(
          new Date(QMEScheduleData.dateOfAppointment) || new Date(),
        );

        const startTimeNew = QMEScheduleData?.startTime
          ? moment(QMEScheduleData.startTime).format("HH:mm")
          : "";

        const endTimeNew = QMEScheduleData?.endTime
          ? moment(QMEScheduleData.endTime).format("HH:mm")
          : "";

        const durationNew = calculateDuration(startTimeNew, endTimeNew);

        setStartTime(startTimeNew);
        setEndTime(endTimeNew);
        setDuration(durationNew);
        setAppointmentType(QMEScheduleData.appointmentTypeId || null);
        setQMEDoctor(QMEScheduleData.qmeDoctorContactId || null);
        setMedicalAssistance(QMEScheduleData?.medical_Assistant_Id || "");
        setAppointmentNumber(QMEScheduleData.appointmentConfirmationNo || "");
        setAppointmentStatus(QMEScheduleData.appointmentStatusId || null);
        setAppointmentCategory(QMEScheduleData.appointmentCategoryId || null);
        setIsMedicalExam(QMEScheduleData?.medicalExamTypeId || null);
        setReasonForVisit(QMEScheduleData.reasonForVisit || "");
        setIsTransportation(QMEScheduleData?.anyAdditionalNeeds?.length > 0);
        setSpecifyNeeds(QMEScheduleData.anyAdditionalNeeds || "");
        setIsInterpreterReq(QMEScheduleData?.isInterpreterRequired == 1);
        setLanguageNeed(QMEScheduleData.interpreterLanguageId || null);
        if (QMEScheduleData?.interpreterLanguageId) {
          const selectedLanguage = baseInterpreterLanguageData?.find(
            (option) => option.value === QMEScheduleData?.interpreterLanguageId,
          );
          setLanguageNeedLabel(selectedLanguage?.label || "");
        }

        setVendor(QMEScheduleData.interpreterVendorId || null);
        setSearchQueryForInterpreter(QMEScheduleData?.interpreterName || "");
        setIsShowInterpreter(!!QMEScheduleData?.interpreterName);
        setInterpreterDetailsName(QMEScheduleData.interpreterName || "");
        setInterpreterDetailsCertiNo(
          QMEScheduleData.interpreterCertificateNumber || "",
        );
        setInterpreterDetailsPhoneNo(
          QMEScheduleData.interpreterPhoneNumber
            ? QMEScheduleData.interpreterPhoneNumber
                .split(",")
                .map((num: string) => num.trim())
            : [],
        );

        setClinicId(QMEScheduleData.contactMedicareListId || null);

        if (QMEScheduleData?.caseSubjectInjuryID) {
          const injuryIds = QMEScheduleData.caseSubjectInjuryID
            ?.split(",")
            ?.map(Number);
          setInjury(injuryIds);
        }

        setResult(QMEScheduleData || {});

        const hospitalList = await fetcQMEDoctorHospitalList(
          QMEScheduleData?.qmeDoctorContactId,
        );

        const matchedHospital = hospitalList?.find(
          (h: any) =>
            Number(h.contactMedicareListId) ===
            Number(QMEScheduleData.contactMedicareListId),
        );

        if (matchedHospital) {
          setSelectedOptionNew(matchedHospital);
          setClientId(matchedHospital.contactMedicareListId);
        } else {
          setSelectedOptionNew(null);
          setClientId(null);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      qmeActiveTab === "Schedule Appointment" &&
      !selectedRowData?.subjectQmeScheduleId
    ) {
      fetchData();
    }
  }, [qmeActiveTab]);

  useEffect(() => {
    if (ismedicalExam === null) {
      const inPersonExam = medicalExamOptions?.find(
        (item: { label: string }) => item.label === "In-Person",
      );

      if (inPersonExam) {
        setIsMedicalExam(inPersonExam.value);
        setMedicalExamValue(inPersonExam.value);
      }
    }
  }, [medicalExamOptions]);

  useEffect(() => {
    if (!isRowActionTriggered) {
      resetData();
      setAppointmentTypeOptions(baseAppointmentTypeData);
      setAppointmentCategoryOptions(baseAppointmentCategoryData);
      setAppointmentStatusOptions(baseAppointmentStatusData);
      setLanguageNeedOptions(baseInterpreterLanguageData);
      setVendorOptions(baseVendorData);
    }
    const inPersonExam = medicalExamOptions?.find(
      (item: { label: string }) => item.label === "In-Person",
    );
    if (inPersonExam && !isRowActionTriggered) {
      setIsMedicalExam(inPersonExam.value);
      setMedicalExamValue(inPersonExam.value);
    }
  }, [qmeActiveTab, activeTab]);

  useEffect(() => {
    setHistorianKey(null);
    setEditorKey(null);
    setTransciberKey(null);
    setRecordReviwerKey(null);
    if (selectedRowData?.subjectQmeScheduleId) {
      fetchData();
      getPostHistorianDetails();
      getActionBasedOnAppointment();
    }
  }, [selectedRowData]);

  useEffect(() => {
    if (result?.contactMedicareListId && clinicDetails?.length) {
      const selectedClinic = clinicDetails?.find(
        (clinic) => clinic.value === result?.contactMedicareListId,
      );

      if (selectedClinic) {
        setClientResult({
          employerName: selectedClinic.providerName || "",
          employerAddress: selectedClinic.providerAddress || "",
          employerCity: selectedClinic.physicalCity || "",
          employerState: selectedClinic.physicalState || "",
          employerZipcode: selectedClinic.physicalZip || "",
          employerCountry: selectedClinic.countryName || "",
          employerContact: "",
          empcontactemailaddress: selectedClinic.emailAddress || "",
          empcontactphonenumber: selectedClinic.phoneNumber || "",
          empcontactfaxnumber: selectedClinic.faxNumber || "",
        });
      }
    }
  }, [clinicDetails, result]);

  const normalizeLabel = (label: string) =>
    label.replace(/-/g, "").trim().toLowerCase();
  const allOptionsList = Object.values(allOptions);
  const optionLookup = allOptionsList.reduce((acc: any, option) => {
    acc[normalizeLabel(option.label)] = option;
    return acc;
  }, {});

  const applyRoleBasedLabel = (option: any, userRole: string) => {
    if (
      userRole === WEB_ROLE.QME_Doctor ||
      userRole === WEB_ROLE.Medical_Assistant
    ) {
      if (option.label === "Reschedule") {
        return { ...option, label: "Request Reschedule" };
      }

      if (option.label === "Cancel") {
        return { ...option, label: "Cancel Request" };
      }
    }

    return option;
  };

  const getActionBasedOnAppointment = async () => {
    try {
      const payload = {
        subjectQMEScheduleIds: String(selectedRowData?.subjectQmeScheduleId),
        triggerEvent: selectedRowData?.scheduleCategory?.toUpperCase(),
      };

      const apiActions = await getAppointmentActionsAccessList(payload);
      const mappedOptions = apiActions
        ?.map((apiOpt: any) => {
          const key = normalizeLabel(apiOpt.label ?? "");
          return optionLookup[key];
        })
        ?.filter(Boolean)
        ?.map((opt) => applyRoleBasedLabel(opt, userRole));

      setFilteredActionOptionsNew(mappedOptions);
    } catch (error) {
      console.error("Error fetching appointment actions:", error);
    }
  };

  const loginUserRolesCheck =
    userRole?.split(",")?.map((role) => role?.trim()) || [];
  const hasUserRole = (roleToCheck: string) =>
    loginUserRolesCheck?.includes(roleToCheck);
  const isCaseManager = hasUserRole(WEB_ROLE.Case_Manager);
  const STATUS_LIST = isCaseManager
    ? DISABLED_STATUSES_CASEMANAGER
    : DISABLED_STATUSES;

  const isDisableAction =
    isStageNonEditable ||
    STATUS_LIST.includes(selectedRowData?.status) ||
    selectedRowData?.scheduleCategory ===
      QME_APPOINTMENT_SCHEDULE_CATEGORY.Past ||
    (selectedRowData?.scheduleCategory ===
      QME_APPOINTMENT_SCHEDULE_CATEGORY.Today &&
      (isCurrentTimeGreater ||
        selectedRowData?.status === QME_APPOINTMENT_STATUS.COMPLETED));

  const isActionButtonDisable =
    STATUS_LIST.includes(selectedRowData?.status) ||
    selectedRowData?.scheduleCategory ===
      QME_APPOINTMENT_SCHEDULE_CATEGORY.Past;

  const fetchHospitalList = async (Id: any) => {
    try {
      const data = await fetcQMEDoctorHospitalList(Id);
      setClinicDetails(data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const calculateDuration = (startTime: any, endTime: any) => {
    if (startTime && endTime) {
      const start = new Date(`1970-01-01T${startTime}:00`);
      const end = new Date(`1970-01-01T${endTime}:00`);
      const diffInMilliseconds = end.getTime() - start.getTime();
      const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

      if (diffInMinutes >= 0) {
        const hours = Math.floor(diffInMinutes / 60);
        const minutes = diffInMinutes % 60;
        let durationString = "";
        if (hours > 0) durationString += `${hours}h`;
        if (minutes > 0) durationString += ` ${minutes}m`;
        return durationString.trim();
      }
    }
    return "";
  };

  const validationCheck = async (Id: any) => {
    try {
      const payload = {
        qmeDoctorContactId: Id,
        dateOfAppointment: dateOfAppointment
          ? formattedDateTime(dateOfAppointment)
          : null,
        startTime:
          startTime && dateOfAppointment
            ? formatDateTime(dateOfAppointment, startTime)
            : null,
        endTime:
          endTime && dateOfAppointment
            ? formatDateTime(dateOfAppointment, endTime)
            : null,
        subjectQMEScheduleId: selectedRowData?.subjectQmeScheduleId
          ? selectedRowData?.subjectQmeScheduleId
          : 0,
      };
      const data = await validateDoctorAppointment(payload);
      if (data?.result?.isConflict == 1) {
        setSnackbarMessage(data?.result?.responseMessage);
        setError("error");
        setSnackbarOpen(true);
        setIsValidateDate(true);
        const isSameTime =
          startTime === currentTime && endTime === currentendTimeNew;
        if (isSameTime) {
          setStartTime("");
          setEndTime("");
          setDuration(null);
        } else {
          setStartTime(currentTime);
          setEndTime(currentendTimeNew);
        }
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error fetching data:", error);
      return false;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (!event.target.closest(".form-floating")) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const cancelAppointment = async (id: any, reason: string) => {
    try {
      setLoading(true);
      const data = await fetchCancelAppointmentreason([id], reason);
      if (data?.statusCode === 200) {
        setShowModal(false);
        setError("success");
        setSnackbarOpen(true);
        setSnackbarMessage("QME Appointment has been cancelled.");
        setCancelReason("");
        setShowModal(false);
        setSelectedRowData(null);
        setTimeout(() => {
          onTabChange();
        }, 1000);
      }
    } catch (error) {
      console.error("Error cancelling appointment:", error);
    } finally {
      setLoading(false);
    }
  };

  // Calculate duration whenever startTime or endTime changes
  useEffect(() => {
    if (startTime && endTime) {
      const start = new Date(`1970-01-01T${startTime}:00`);
      const end = new Date(`1970-01-01T${endTime}:00`);
      const diffInMilliseconds = end.getTime() - start.getTime();
      const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

      if (diffInMinutes >= 0) {
        const hours = Math.floor(diffInMinutes / 60);
        const minutes = diffInMinutes % 60;
        let durationString = "";
        if (hours > 0) durationString += `${hours}h`;
        if (minutes > 0) durationString += ` ${minutes}m`;
        setDuration(durationString.trim());
        setIsValidateDate(false);
      } else {
        setDuration("");
      }

      if (QMEDoctor && isStartTimeChange && !isDisableAction) {
        validationCheck(QMEDoctor);
      }
    } else {
      setDuration("");
      setIsValidateDate(false);
      setisStartTimeChange(false);
    }
  }, [startTime, endTime]);

  const handleStartTimeChange = (time: string) => {
    setStartTime(time);
    setisStartTimeChange(true);

    // Validate if the time is in HH:MM format
    const isValidTime = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time);
    if (isValidTime) {
      const [hours, minutes] = time.split(":").map(Number);

      // Calculate total minutes from 00:00
      const totalMinutes = hours * 60 + minutes;
      const endTotalMinutes = totalMinutes + 1;

      // If end time exceeds 23:59 (1439 minutes), cap it
      const finalMinutes = Math.min(endTotalMinutes, 1439);
      const endHours = Math.floor(finalMinutes / 60);
      const endMinutes = finalMinutes % 60;

      const newEndTime = `${String(endHours).padStart(2, "0")}:${String(
        endMinutes,
      ).padStart(2, "0")}`;
      setEndTime(newEndTime);
    } else {
      setEndTime("");
    }
  };

  const handleStartTimeChangeForAction = (time: string) => {
    setStartTimeForAction(time);
  };

  const validateData = () => {
    const validationErrors = validateScheduleAppointment(
      dateOfAppointment,
      startTime,
      endTime,
      appointmentType,
      QMEDoctor,
      appointmentCategory,
      ismedicalExam,
      specifyNeeds,
      isTransportation,
      isInterpreterReq,
      languageNeed,
      vendor,
      clinicId,
      showAddClinic,
      addressDetails,
      emailAddress,
      phoneNumber,
      faxNumber,
      interpreterDetailsName,
      interpreterDetailsPhoneNo,
      interpreterDetailsCertiNo,
      showAddInterpreter,
      injury,
      isManualEntry,
      manualAddress,
      manualLocation,
      manualCity,
      manualCountry,
      manualState,
      manualZip,
    );

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as Element;
      if (target.closest("#datepicker-input, .date_ic, .react-datepicker")) {
        return;
      }
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setFilteredResultsForInterpreter([]);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSuggestionSelect = (suggestion: LocationSuggestion) => {
    const newStateCode = suggestion.physicalStateCode || normalizeState(suggestion.physicalState || "");
    const newCountryCode = normalizeCountry(suggestion.country || "USA");

    if (suggestion.source === "google") {
      setPendingGoogleLocation({
        source: "google",
        providerName: suggestion.providerName,
        providerAddress: suggestion.providerAddress,
        physicalCity: suggestion.physicalCity,
        physicalState: newStateCode,
        physicalZip: suggestion.physicalZip,
        countryName: newCountryCode,
        county: suggestion.county,
        areaName: suggestion.areaName || "",
        latitude: isValidCoordinate(suggestion.latitude) ? String(suggestion.latitude) : "",
        longitude: isValidCoordinate(suggestion.longitude) ? String(suggestion.longitude) : "",
      });
    } else {
      setPendingGoogleLocation(null);
    }
    setSuggestionSelected(true);
    setSuggestionFilled({
      city: !!suggestion.physicalCity,
      state: !!newStateCode,
      country: !!newCountryCode,
      zip: !!suggestion.physicalZip,
    });
    setAddressDetails({
      city: suggestion.physicalCity || "",
      state: newStateCode,
      country: newCountryCode,
      zip: suggestion.physicalZip || "",
      medicareId: suggestion.medicareId || "",
      providerName: suggestion.providerName || "",
      providerAddress: suggestion.providerAddress || "",
    });
  };

  const handleSearchChangeForInterpreter = async (
    e: ChangeEvent<HTMLInputElement>,
  ) => {
    const query = e.target.value;
    if (query.startsWith(" ")) {
      return;
    }
    setSearchQueryForInterpreter(query);
    const trimmedQuery = query.trim();
    if (trimmedQuery.length < 3) {
      setFilteredResultsForInterpreter([]);
      return;
    }

    try {
      const response: any = await fetchInterpreterListDetails(
        trimmedQuery,
        languageNeedLabel,
      );

      if (Array.isArray(response.result)) {
        setFilteredResultsForInterpreter(response.result);
      } else {
        setFilteredResultsForInterpreter([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSelectDropdown = (option: any) => {
    setSelectedOptionNew(option);
    setClinicId(option.contactMedicareListId);
    setDropdownOpen(false);
    setClientResult({
      employerName: option.providerName || "",
      employerAddress: option.providerAddress || "",
      employerCity: option.physicalCity || "",
      employerState: option.physicalState || "",
      employerZipcode: option.physicalZip || "",
      employerCountry: option.countryName || "",
      employerContact: "",
      empcontactemailaddress: option.emailAddress || "",
      empcontactphonenumber: option.phoneNumber || "",
      empcontactfaxnumber: option.faxNumber || "",
    });
  };

  const handleSelectInterpreterDropdown = (option: any) => {
    setIsShowInterpreter(true);
    setSelectedOptionForInterpreter(option);
    setSearchQueryForInterpreter(option.interpreterName || "");
    setInterpreterDetailsName(option.interpreterName || "");
    setInterpreterDetailsPhoneNo(
      option.interpreterPhoneNumber
        ? option.interpreterPhoneNumber
            .split(",")
            .map((num: string) => num.trim())
        : [],
    );
    setInterpreterDetailsCertiNo(option.interpreterCertificateNumber || "");
    setDropdownOpenForInterpreter(false);
    setFilteredResultsForInterpreter([]);
  };

  const handleSubmit = async () => {
    if (validateData()) {
      setLoading(true);
      const isConflict = await validationCheck(QMEDoctor);
      if (isConflict) {
        setLoading(false);
        return;
      }

      const subjectQMEScheduleId = selectedRowData?.subjectQmeScheduleId || 0;
      const appointmentStatusID = appointmentStatusOptions?.find(
        (item) => item.label === QME_APPOINTMENT_STATUS.SCHEDULED,
      )?.value;
      const appointmentStatusRescheduledID = appointmentStatusOptions?.find(
        (item) => item.label === QME_APPOINTMENT_STATUS.RESCHEDULED,
      )?.value;
      const appointmentStatusLabel = appointmentStatusOptions?.find(
        (item) => item.label === QME_APPOINTMENT_STATUS.RESCHEDULED,
      )?.label;

      const medicalExamID = medicalExamOptions?.find(
        (item) => item.label === "In-Person",
      )?.value;

      let fixedLoc: { latitude?: number | null; longitude?: number | null } =
        {};
      if (manualLocation) {
        const addressInDetails = `${manualAddress}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
        const locationInDetails = `${manualLocation}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
        const locationFullDetails = `${manualLocation}, ${manualAddress}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;

        const placeResult = await getPlaceByAddress({
          name: locationInDetails,
          address: addressInDetails,
          fullAddress: locationFullDetails,
        });
        if (placeResult) {
          fixedLoc = {
            latitude: placeResult.latitude,
            longitude: placeResult.longitude,
          };
        }
      }

      let splInstructionsPayload: any[] = [];
      splInstructionsPayload = instructionOption.map((opt: any) => ({
        splInstructionID: opt.value,
        splInstructionData: "",
      }));

      const basePayload = {
        caseSubjectId: caseSubjectId,
        subjectQMEScheduleId: subjectQMEScheduleId,
        dateOfAppointment: dateOfAppointment
          ? formatDateTime(dateOfAppointment)
          : null,
        startTime:
          startTime && dateOfAppointment
            ? formatDateTime(dateOfAppointment, startTime)
            : null,
        endTime:
          endTime && dateOfAppointment
            ? formatDateTime(dateOfAppointment, endTime)
            : null,
        appointmentTypeId: appointmentType || null,
        appointmentCategoryId: appointmentCategory || null,
        qmeDoctorContactId: Number(QMEDoctor) || null,
        appointmentStatusId:
          selectedRowData?.status ===
          QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE
            ? appointmentStatusRescheduledID
            : selectedRowData?.subjectQmeScheduleId
              ? appointmentStatusID === appointmentStatus
                ? appointmentStatusRescheduledID
                : appointmentStatus
              : appointmentStatusID,
        appointmentStatusLable: selectedRowData?.subjectQmeScheduleId
          ? appointmentStatusLabel
          : QME_APPOINTMENT_STATUS.SCHEDULED,
        appointmentConfirmationNo: appointmentNumber || "",
        reasonForVisit: reasonForVisit || "",
        medicalExamTypeId:
          ismedicalExam != null ? ismedicalExam : medicalExamID,
        anyAdditionalNeeds: specifyNeeds || "",
        isInterpreterRequired: isInterpreterReq ? 1 : 0,
        interpreterLanguageId: languageNeed || null,
        interpreterVendorId: vendor || null,
        interpreterName: interpreterDetailsName,
        interpreterPhoneNumber:
          interpreterDetailsPhoneNo?.length > 0
            ? interpreterDetailsPhoneNo.join(",")
            : "",
        interpreterCertificateNumber: interpreterDetailsCertiNo,
        caseSubjectInjuryId: injury.join(",") || "",
        contactMedicareListId: clinicId ? clinicId : null,
        medicareId: isManualEntry ? null : addressDetails?.medicareId || null,
        providerName: manualLocation
          ? manualLocation
          : clientResult?.employerName && !showAddClinic
            ? clientResult.employerName
            : addressDetails?.providerName,

        providerAddress: manualAddress
          ? manualAddress
          : clientResult?.employerAddress && !showAddClinic
            ? clientResult.employerAddress
            : addressDetails?.providerAddress,
        physicalCity: manualCity
          ? manualCity
          : clientResult?.employerCity && !showAddClinic
            ? clientResult.employerCity
            : addressDetails?.city,
        physicalState: manualState
          ? manualState
          : clientResult?.employerState && !showAddClinic
            ? clientResult.employerState
            : addressDetails?.state,
        physicalZip: manualZip
          ? manualZip
          : clientResult?.employerZipcode && !showAddClinic
            ? clientResult.employerZipcode
            : addressDetails?.zip,
        emailAddress: emailAddress?.length > 0 ? emailAddress.join(",") : "",
        phoneNumber: phoneNumber?.length > 0 ? phoneNumber.join(",") : "",
        faxNumber: faxNumber?.length > 0 ? faxNumber.join(",") : "",
        medicalAssistantId: medicalAssistance || null,
      };

      const useGoogleFallback =
        showAddClinic &&
        !isManualEntry &&
        pendingGoogleLocation?.source === "google";

      const payload = {
        ...basePayload,
        ...(useGoogleFallback && {
          latitude: String(pendingGoogleLocation.latitude),
          longitude: String(pendingGoogleLocation.longitude),
          splInstructions: splInstructionsPayload,
        }),
        ...(!useGoogleFallback &&
          manualLocation &&
          isValidCoordinate(fixedLoc?.latitude) &&
          isValidCoordinate(fixedLoc?.longitude) && {
            latitude: String(fixedLoc.latitude),
            longitude: String(fixedLoc.longitude),
          }),
        ...(!useGoogleFallback &&
          manualLocation && {
            splInstructions: splInstructionsPayload,
          }),
      };

      try {
        let response: any;
        if (subjectQMEScheduleId) {
          // Update existing appointment
          response = await updateQMEScheduleDetails(payload);
        } else {
          // Create new appointment
          response = await addQMEScheduleDetails(payload);
        }

        if (response?.isSuccess && response?.statusCode == 200) {
          setSnackbarMessage(
            subjectQMEScheduleId
              ? "Appointment Updated Successfully."
              : "Appointment Scheduled Successfully.",
          );
          setError("success");
          setSnackbarOpen(true);
          setShowAddInterpreter(false);
          // setSpecialization('');
          setShowAddClinic(false);
          setSearchQuery("");
          setSearchQueryForInterpreter("");
          setInterpreterDetailsPhoneNo([]);
          setInterpreterDetailsCertiNo("");
          setSearchQueryForInterpreter("");
          setIsShowInterpreter(false);
          setClinicId(null);
          setSelectedOptionNew(null);
          setSuggestionSelected(false);
          setSuggestionFilled({ city: false, state: false, country: false, zip: false });
          setAddressDetails({
            city: "",
            state: "",
            country: "",
            zip: "",
            medicareId: "",
            providerName: "",
            providerAddress: "",
          });
          setPhoneNumber([]);
          setEmailAddress([]);
          setFaxNumber([]);
          setSelectedRowData(null);
          setInjury([]);
          setInjuryDetails({
            claimNo: "",
            dateOfIncident: "",
            insuranceCarrier: "",
          });
          if (!subjectQMEScheduleId && !isQMEScheduleAvailable) {
            dispatchNew(setQMEScheduleAvailable(true));
          }
          dispatchNew(fetchCaseStages(caseInfoId));
          setTimeout(() => {
            onTabChange();
          }, 1000);
        } else {
          setSnackbarMessage(
            response?.message || "Failed to process appointment.",
          );
          setError("error");
          setSnackbarOpen(true);
          setSearchQuery("");
          setClinicId(null);
          setSelectedOptionNew(null);
          setSuggestionSelected(false);
          setSuggestionFilled({ city: false, state: false, country: false, zip: false });
          setAddressDetails({
            city: "",
            state: "",
            country: "",
            zip: "",
            medicareId: "",
            providerName: "",
            providerAddress: "",
          });
          setPhoneNumber([]);
          setEmailAddress([]);
          setFaxNumber([]);
        }
      } catch (error) {
        console.error("Error processing appointment:", error);
        setSnackbarMessage(
          "An error occurred while processing the appointment.",
        );
        setSnackbarOpen(true);
        setError("error");
      } finally {
        setLoading(false);
        setisStartTimeChange(false);
      }
    }
  };

  const handleCancel = () => {
    setShowModal(true);
  };

  const handleCancelButton = () => {
    setShowModalNew(true);
  };
  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };
  const download110Form = () => {
    setSnackbarMessage("Generating 110/SIBTF Form");
    setError("success");
    setSnackbarOpen(true);
    const ids = Array.isArray(selectedRowData)
      ? selectedRowData.map((row: any) => row.subjectQmeScheduleId)
      : [selectedRowData.subjectQmeScheduleId];
    if (CaseTypeName == "SIBTF (Subsequent Injuries Benefits Trust Fund)") {
      downloadSIBTFForm(ids);
    } else {
      downloadQMEFormsZip(ids);
    }
  };
  const handleConfirmCancelButton = async () => {
    if (selectedRowData?.subjectQmeScheduleId) {
      await fetchData();
    } else {
      resetData();
    }
    setShowModalNew(false);
  };

  const resetData = () => {
    setDateOfAppointment(new Date());
    setStartTime(currentTime);
    setEndTime(currentendTimeNew);
    setisStartTimeChange(false);
    setDuration(null);
    setAppointmentType(null);
    setSpecialization("");
    setMedicalAssistance(null);
    setAppointmentNumber("");
    setAppointmentStatus(null);
    setAppointmentCategory(null);
    setIsMedicalExam(medicalExamValue);
    setReasonForVisit(null);
    setIsTransportation(false);
    setSpecifyNeeds("");
    setIsInterpreterReq(false);
    setLanguageNeed(null);
    setIsShowInterpreter(false);
    setShowAddInterpreter(false);
    setSelectedOptionForInterpreter(null);
    setInterpreterDetailsName("");
    setInterpreterDetailsPhoneNo([]);
    setInterpreterDetailsCertiNo("");
    setSearchQueryForInterpreter("");
    setVendor(null);
    setClinicId(null);
    setResult({});
    setClientResult({
      employerName: "",
      employerAddress: "",
      employerCity: "",
      employerState: "",
      employerZipcode: "",
      employerCountry: "",
      employerContact: "",
      empcontactemailaddress: "",
      empcontactphonenumber: "",
      empcontactfaxnumber: "",
    });
    setPhoneNumber([]);
    setEmailAddress([]);
    setFaxNumber([]);
    setShowAddInterpreter(false);
    setShowAddClinic(false);
    setSearchQuery("");
    setSearchQueryForInterpreter("");
    setSelectedOptionNew(null);
    setSuggestionSelected(false);
    setSuggestionFilled({ city: false, state: false, country: false, zip: false });
    setAddressDetails({
      city: "",
      state: "",
      country: "",
      zip: "",
      medicareId: "",
      providerName: "",
      providerAddress: "",
    });
    setPendingGoogleLocation(null);
    setQMEDoctor(QMEDoctorReset);
    setInjury(injuryReset);
  };

  const handleConfirmCancel = async () => {
    if (!cancelReason.trim()) {
      setReasonError(true);
      return;
    }

    setReasonError(false);

    if (selectedRowData?.subjectQmeScheduleId) {
      await cancelAppointment(
        selectedRowData.subjectQmeScheduleId,
        cancelReason,
      );
    } else {
      resetData();
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleBack = () => {
    onCancel("Cancel");
    setHistorianKey(null);
    setEditorKey(null);
    setTransciberKey(null);
    setRecordReviwerKey(null);
  };

  const handleCalenderViewBack = () => {
    onTabChange();
  };

  const hasChanges = () => {
    const isStartTimeSame = startTime != currentTime;
    const isEndTimeSame = endTime != currentendTimeNew;
    const isStartTimeChange =
      startTime !== moment(result?.startTime).format("HH:mm");
    const isEndTimeChange = endTime !== moment(result?.endTime).format("HH:mm");
    const isTimeSame = startTime != currentTime && endTime != currentendTimeNew;
    const isDifferentTime =
      startTime !== moment(result?.startTime).format("HH:mm") &&
      endTime !== moment(result?.endTime).format("HH:mm");
    const isDateSame =
      moment(dateOfAppointment).format("YYYY-MM-DD") !=
      moment(new Date()).format("YYYY-MM-DD");
    const isDifferentDate =
      moment(dateOfAppointment).format("YYYY-MM-DD") !==
      moment(result?.dateOfAppointment).format("YYYY-MM-DD");
    const isLanguageNeed = selectedRowData?.subjectQmeScheduleId
      ? result?.interpreterLanguageId == 0
        ? null
        : result?.interpreterLanguageId
      : (result?.interpreterLanguageId ?? null);
    const isVendor = selectedRowData?.subjectQmeScheduleId
      ? result?.interpreterVendorId == 0
        ? null
        : result?.interpreterVendorId
      : (result?.interpreterVendorId ?? null);
    const isStatus = selectedRowData?.subjectQmeScheduleId
      ? appointmentStatus !== result?.appointmentStatusId
      : false;
    const isMedicalExamNew = selectedRowData?.subjectQmeScheduleId
      ? ismedicalExam != result?.medicalExamTypeId
      : false;

    return (
      (selectedRowData?.subjectQmeScheduleId
        ? isDifferentDate ||
          isDifferentTime ||
          isStartTimeChange ||
          isEndTimeChange
        : isDateSame || isTimeSame || isStartTimeSame || isEndTimeSame) ||
      appointmentType !== (result?.appointmentTypeId ?? null) ||
      QMEDoctor !== (result?.qmeDoctorContactId ?? null) ||
      appointmentNumber != (result?.appointmentConfirmationNo ?? "") ||
      (selectedRowData?.subjectQmeScheduleId && isStatus) ||
      appointmentCategory !== (result?.appointmentCategoryId ?? null) ||
      (selectedRowData?.subjectQmeScheduleId && isMedicalExamNew) ||
      reasonForVisit != (result?.reasonForVisit ?? null) ||
      specifyNeeds != (result?.anyAdditionalNeeds ?? "") ||
      languageNeed !== isLanguageNeed ||
      vendor !== isVendor ||
      clinicId !== (result?.contactMedicareListId ?? null)
    );
  };
  const href = useHref("/search-case/view_qme_schedule");

  // const handleOpenNewTab = () => {
  //   if (QMEDoctor) {
  //     const selectedDoctor = QMEDoctorOptions?.find(
  //       (doctor) => doctor.value === QMEDoctor,
  //     );

  //     sessionStorage.setItem(
  //       "selectedDoctorInfo",
  //       JSON.stringify({
  //         id: QMEDoctor,
  //         name: selectedDoctor?.label || "",
  //         appointmentDate: dateOfAppointment || null,
  //       }),
  //     );

  //     window.open("/#/search-case/view_qme_schedule", "_blank");
  //   }
  // };

  const handleOpenDrawer = () => {
    if (QMEDoctor) {
      const selectedDoctor = QMEDoctorOptions?.find(
        (doctor) => doctor.value === QMEDoctor,
      );

      const doctorData = {
        id: QMEDoctor,
        name: selectedDoctor?.label || "",
        appointmentDate: dateOfAppointment || null,
      };

      setSelectedDoctorInfo(doctorData);
      setShowViewScheduleDrawer(true);
      setSelectedRowData(null);
      dispatchNew(setIsViewSchedule(true));
    }
  };

  const handleOpenNewTabForMap = async () => {
    if (QMEDoctor) {
      const selectedDoctor = QMEDoctorOptions?.find(
        (doctor) => doctor.value === QMEDoctor,
      );
      const data = await GetDoctorDetails(Number(QMEDoctor));
      const rawLocationJson = data?.associatedLocations;
      const locationList: Location[] = rawLocationJson.map((loc: any) => ({
        fax: loc?.faxnumber || "NA",
        phone: loc?.phonenumber || "NA",
        email: loc?.emailaddress || "NA",
        locationname: loc?.locationname || "NA",
        locationaddress: loc?.locationaddress || "NA",
        latitude: loc?.latitude || null,
        longitude: loc?.longitude || null,
      }));

      sessionStorage.setItem(
        "selectedMapData",
        JSON.stringify({
          locations: locationList,
          tab: "QME Schedule",
        }),
      );

      window.open("/#/map/associated_locations", "_blank");
    }
  };

  const [scheduleAppointmentKey, setscheduleAppointmentKey] = useState<
    string | null
  >("0");

  const scheduleAppointmentAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={scheduleAppointmentKey}
      onSelect={(key) => setscheduleAppointmentKey(key as string)}
    />
  );

  const [medicalExamKey, setmedicalExamKey] = useState<string | null>("0");

  const medicalExamAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={medicalExamKey}
      onSelect={(key) => setmedicalExamKey(key as string)}
    />
  );

  const [addcomDetailKey, setaddcomDetailKey] = useState<string | null>("0");
  const [interpreterDetailKey, setInterpreterDetailKey] = useState<
    string | null
  >("0");
  const [injuryDetailKey, setInjuryDetailKey] = useState<string | null>("0");

  const addcomDetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={addcomDetailKey}
      onSelect={(key) => setaddcomDetailKey(key as string)}
    />
  );

  const [clinicDetailKey, setclinicDetailKey] = useState<string | null>("0");
  const mintimeNew = moment(startTime, "HH:mm")
    .add(1, "minutes")
    .format("HH:mm");

  const clinicDetailFormAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={clinicDetailKey}
      onSelect={(key) => setclinicDetailKey(key as string)}
    />
  );

  const interpreterDetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={interpreterDetailKey}
      onSelect={(key) => setInterpreterDetailKey(key as string)}
    />
  );

  const injuryDetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={injuryDetailKey}
      onSelect={(key) => setInjuryDetailKey(key as string)}
    />
  );

  const handleEnterNewLocation = () => {
    setIsManualEntry(true);
    setIsManualLocation(false);
  };

  const [searchResults, setSearchResults] = useState<
    HospitalClinicSearchResult[]
  >([]);

  const handleSearch = async (query: string) => {
    try {
      // Optional: setLoading(true);

      const response = await searchManualZipCode({
        SearchString: query,
        pageNo: 0,
        pageSize: 0,
        sortColumn: "",
        sortOrder: "",
      });

      const results: HospitalClinicSearchResult[] = response?.result || [];

      if (results.length > 0) {
        setSearchResults(results);

        const cities = [
          ...new Set(results.map((r) => r.physicalCity).filter(Boolean)),
        ];
        const zips = [
          ...new Set(results.map((r) => r.physicalZip).filter(Boolean)),
        ];
        const states = [
          ...new Set(results.map((r) => r.physicalState).filter(Boolean)),
        ];
        const countries = [
          ...new Set(results.map((r) => r.country).filter(Boolean)),
        ];

        setCityOptions(cities);
        setZipOptions(zips);
        setStateOptions(states);
        setCountryOptions(countries);

        // Clear only if selected value is no longer valid
        if (!cities.includes(manualCity)) setManualCity("");
        if (!zips.includes(manualZip)) setManualZip("");
        if (!states.includes(manualState)) setManualState("");
        if (!countries.includes(manualCountry)) setManualCountry("");
      }
    } catch (error) {
      console.error("Error searching clinic data:", error);
    } finally {
      // Optional: setLoading(false);
    }
  };

  // Update dropdown options from unfiltered searchResults
  useEffect(() => {
    const cities = [
      ...new Set(searchResults.map((r) => r.physicalCity).filter(Boolean)),
    ];
    const states = [
      ...new Set(searchResults.map((r) => r.physicalState).filter(Boolean)),
    ];
    const countries = [
      ...new Set(searchResults.map((r) => r.country).filter(Boolean)),
    ];
    const zips = [
      ...new Set(searchResults.map((r) => r.physicalZip).filter(Boolean)),
    ];

    setCityOptions(cities);
    setStateOptions(states);
    setCountryOptions(countries);
    setZipOptions(zips);
  }, [searchResults]);

  useEffect(() => {
    if (!manualCity && !manualZip) return;

    let filtered = [...searchResults];

    if (manualCity?.trim()) {
      filtered = filtered.filter(
        (item) =>
          item.physicalCity?.toLowerCase() === manualCity.trim().toLowerCase(),
      );
    }

    if (manualZip?.trim()) {
      filtered = filtered.filter(
        (item) =>
          item.physicalZip?.toLowerCase() === manualZip.trim().toLowerCase(),
      );
    }

    const cities = [
      ...new Set(filtered.map((r) => r.physicalCity).filter(Boolean)),
    ];
    const zips = [
      ...new Set(filtered.map((r) => r.physicalZip).filter(Boolean)),
    ];
    const states = [
      ...new Set(filtered.map((r) => r.physicalState).filter(Boolean)),
    ];
    const countries = [
      ...new Set(filtered.map((r) => r.country).filter(Boolean)),
    ];

    setCityOptions(cities);
    setZipOptions(zips);
    setStateOptions(states);
    setCountryOptions(countries);

    if (cities.length === 1 && !manualCity) setManualCity(cities[0]);
    if (zips.length === 1 && !manualZip) setManualZip(zips[0]);
    if (states.length === 1 && !manualState) setManualState(states[0]);
    if (countries.length === 1 && !manualCountry)
      setManualCountry(countries[0]);
  }, [manualCity, manualZip, searchResults]);

  let actionOptions: ActionOption[] = [];

  const includeInterpreterNoShow = result?.isInterpreterRequired
    ? [
        {
          value: QME_APPOINTMENT_STATUS.INTERPRETER_NO_SHOW,
          label: "Interpreter No Show",
        },
      ]
    : [];

  if (
    selectedRowData?.scheduleCategory ===
    QME_APPOINTMENT_SCHEDULE_CATEGORY.Today
  ) {
    actionOptions = [
      {
        value: QME_APPOINTMENT_STATUS.PATIENT_NO_SHOW,
        label: "Patient No Show",
      },
      ...includeInterpreterNoShow,
      {
        value: QME_APPOINTMENT_STATUS.QME_NO_SHOW,
        label: "QME Doctor No Show",
      },
      {
        value: QME_APPOINTMENT_STATUS.PATIENT_CHECKED_IN,
        label: "Patient Checked In",
      },
      ...(isCurrentTimeGreater
        ? []
        : [{ value: QME_APPOINTMENT_STATUS.CANCELLED, label: "Cancel" }]),
      {
        value: QME_APPOINTMENT_STATUS.COMPLETED,
        label: "Complete",
      },
    ];
  } else if (
    selectedRowData?.scheduleCategory ===
    QME_APPOINTMENT_SCHEDULE_CATEGORY.Upcoming
  ) {
    actionOptions = [
      { value: QME_APPOINTMENT_STATUS.CANCELLED, label: "Cancel" },
    ];
  }

  let filteredActionOptions = filterByAccess(
    actionOptions,
    actionOptionFeatureMap,
  );

  const filteredActions = filterByAccess(
    [
      { label: "Generate 110/SIBTF Form" },
      { label: "View QME Schedule" },
      { label: "Doctors Location Map" },
    ],
    actionOptionFeatureMap,
  );

  const actionsAccess = filteredActions?.map((opt) => opt.label);
  const filteredGenerateForm = actionsAccess.includes(
    "Generate 110/SIBTF Form",
  );
  const filteredViewSchedule = actionsAccess.includes("View QME Schedule");
  const filteredDoctorLocationMap = actionsAccess.includes(
    "Doctors Location Map",
  );

  const roles = userRole?.split(",").map((role) => role.trim()) || [];
  const hasRole = (roleToCheck: string) => roles.includes(roleToCheck);
  const isRoleQMEDoctorRaw = hasRole(WEB_ROLE.QME_Doctor);
  const isRoleMedicalAssistance = hasRole(WEB_ROLE.Medical_Assistant);
  const isRoleQMEDoctor = !!isRoleQMEDoctorRaw;
  const showButton = (filteredActionOptions?.length ?? 0) > 0;

  if (
    (isRoleQMEDoctorRaw || isRoleMedicalAssistance) &&
    selectedRowData?.status === QME_APPOINTMENT_STATUS.SCHEDULED &&
    ((selectedRowData?.scheduleCategory ===
      QME_APPOINTMENT_SCHEDULE_CATEGORY.Today &&
      !isCurrentTimeGreater) ||
      selectedRowData?.scheduleCategory ===
        QME_APPOINTMENT_SCHEDULE_CATEGORY.Upcoming)
  ) {
    filteredActionOptions = [
      ...filteredActionOptions,
      {
        value: QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE,
        label: "Reschedule Request",
      },
    ];
  }

  const handleActionChange = async (value: string | number) => {
    const selectedOption = filteredActionOptionsNew.find(
      (option) => option.value === value,
    );
    const label = selectedOption?.label || String(value);
    setSelectedAction(value);
    setSelectedActionlabel(label);
    setShowModalForAction(true);
    if (
      value === QME_APPOINTMENT_STATUS.RESCHEDULED ||
      value == QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE
    ) {
      const checkAvailabilityData = await getDoctorNextAvailability(
        selectedRowData.subjectQmeScheduleId,
      );
      if (checkAvailabilityData && checkAvailabilityData?.length > 0) {
        const nextAvailableStartDate =
          checkAvailabilityData[0]?.nextAvailableStartDate;
        const nextAvailableStartTime =
          checkAvailabilityData[0]?.nextAvailableStartTime;
        if (nextAvailableStartDate) {
          const parsedDate = new Date(nextAvailableStartDate);
          setDateForAction(parsedDate);
          setLocationForAction(checkAvailabilityData[0]?.providerAddress || "");
        }
        if (nextAvailableStartTime) {
          const formattedTime = nextAvailableStartTime
            ?.split(":")
            ?.slice(0, 2)
            ?.join(":");
          setStartTimeForAction(formattedTime);
          setMedicareLocation(checkAvailabilityData[0]?.providerAddress);
        }
      }
    }
  };

  const handleCloseModalForAction = () => {
    setShowModalForAction(false);
    setDateForAction(new Date());
    setStartTimeForAction(currentTime);
    setReasonForAction("");
    setLocationForAction("");
    setSelectedAction("");
    setSelectedActionlabel("");
  };

  const handleConfirmActionButton = async () => {
    setShowModalForAction(false);
    try {
      let response: any;
      if (
        selectedAction === QME_APPOINTMENT_STATUS.RESCHEDULED &&
        (userRole == WEB_ROLE.QME_Doctor ||
          userRole == WEB_ROLE.Medical_Assistant ||
          userRole == WEB_ROLE.Case_Manager)
      ) {
        if (!dateForAction || !startTimeForAction) {
          const errorMessages = {
            dateForAction: "Please select a date for rescheduling.",
            startTimeForAction: "Please select a time for rescheduling.",
          };

          const missingField = !dateForAction
            ? "dateForAction"
            : "startTimeForAction";
          setSnackbarMessage(errorMessages[missingField]);
          setError("error");
          setSnackbarOpen(true);
          return;
        }
        setLoading(true);
        const formatedActionDate = dateForAction
          ? formatDateTime(dateForAction)
          : null;
        const dateOnly = formatedActionDate?.split("T")[0];
        const reschedulePayload = {
          subjectQmeScheduleIds: String(selectedRowData?.subjectQmeScheduleId),
          startDate: dateForAction ? dateOnly : null,
          startTime:
            startTimeForAction && dateForAction
              ? formatDateTime(dateForAction, startTimeForAction)
              : null,
          providerAddress: locationForAction || "",
          note: reasonForAction || "",
        };
        if (userRole == WEB_ROLE.Case_Manager) {
          const subjectQMEScheduleIdRes =
            selectedRowData?.subjectQmeScheduleId || 0;
          const appointmentStatusRescheduledIDRes =
            appointmentStatusOptions?.find(
              (item) => item.label === QME_APPOINTMENT_STATUS.RESCHEDULED,
            )?.value;
          const appointmentStatusLabelRes = appointmentStatusOptions?.find(
            (item) => item.label === QME_APPOINTMENT_STATUS.RESCHEDULED,
          )?.label;

          const reqPayload = {
            caseSubjectId: caseSubjectId,
            subjectQMEScheduleId: subjectQMEScheduleIdRes,
            dateOfAppointment: dateForAction
              ? formatDateTime(dateForAction)
              : null,
            startTime:
              startTimeForAction && dateForAction
                ? formatDateTime(dateForAction, startTimeForAction)
                : null,
            endTime:
              startTimeForAction && dateForAction
                ? formatDateTime(
                    dateForAction,
                    (() => {
                      const [h, m] = startTimeForAction.split(":").map(Number);
                      const end = new Date(dateForAction);
                      end.setHours(h);
                      end.setMinutes(m + 1);
                      return end.toTimeString().slice(0, 5);
                    })(),
                  )
                : null,

            appointmentTypeId: null,
            appointmentCategoryId: null,
            qmeDoctorContactId: Number(QMEDoctor) || null,
            medicalAssistantId: medicalAssistance || null,
            appointmentStatusId: appointmentStatusRescheduledIDRes,
            appointmentStatusLable: appointmentStatusLabelRes,
            appointmentConfirmationNo: null,
            reasonForVisit: null,
            medicalExamTypeId: null,
            anyAdditionalNeeds: null,
            isInterpreterRequired: null,
            interpreterLanguageId: null,
            interpreterVendorId: null,
            interpreterName: null,
            interpreterPhoneNumber: null,
            interpreterCertificateNumber: null,
            caseSubjectInjuryId: null,
            contactMedicareListId: null,
            medicareId: null,
            providerName: null,
            providerAddress: null,
            physicalCity: null,
            physicalState: null,
            physicalZip: null,
            emailAddress: null,
            phoneNumber: null,
            faxNumber: null,
          };
          response = await updateQMEScheduleDetails(reqPayload);
        } else {
          response = await RequestForRescheduleAppointment(reschedulePayload);
        }
      } else {
        setLoading(true);
        const statusText =
          selectedAction === QME_APPOINTMENT_STATUS.CANCELLED &&
          (userRole === WEB_ROLE.QME_Doctor ||
            userRole === WEB_ROLE.Medical_Assistant)
            ? QME_APPOINTMENT_STATUS.QME_REQUESTED_CANCELLATION
            : selectedAction;
        const actionPayload = {
          qmeScheduleIds: String(selectedRowData?.subjectQmeScheduleId),
          statusText: statusText,
          notes: reasonForAction,
        };

        response = await AppointmentBulkUpdateStatus(actionPayload);
      }

      if (
        selectedAction === QME_APPOINTMENT_STATUS.RESCHEDULED &&
        userRole !== WEB_ROLE.Case_Manager
          ? response?.data?.subjectQmeScheduleId
          : response?.isSuccess
      ) {
        setSnackbarMessage("Appointment status updated successfully.");
        setError("success");
        setSnackbarOpen(true);
        setDateForAction(new Date());
        setStartTimeForAction(currentTime);
        setReasonForAction("");
        setLocationForAction("");
        setSelectedAction("");
        setSelectedActionlabel("");
        setSelectedRowData(null);
        setTimeout(() => {
          onTabChange();
        }, 1000);
      } else {
        setSnackbarMessage(
          response?.message || "Failed to update appointment action.",
        );
        setError("error");
        setSnackbarOpen(true);
        setDateForAction(new Date());
        setStartTimeForAction(currentTime);
        setReasonForAction("");
        setLocationForAction("");
        setSelectedAction("");
        setSelectedActionlabel("");
      }
    } catch (error) {
      console.error("Error updating appointment status:", error);
      setSnackbarMessage("Something went wrong. Please try again.");
      setError("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const [historionData, setHistorionData] = useState<any[]>([]);
  const [recordReviewerData, setRecordReviewerData] = useState<any[]>([]);
  const [editorData, setEditorData] = useState<any[]>([]);
  const [transcriberData, setTranscriberData] = useState<any[]>([]);
  const [qmeProcessStatusData, setQMEProcessStatusData] = useState<any | null>(
    null,
  );

  const [postQMEKey, setPostQMEExamKey] = useState<string | null>("0");

  const postQMEAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={postQMEKey}
      onSelect={(key) => {
        setPostQMEExamKey(key as string);
        setHistorianKey(null);
        setEditorKey(null);
        setTransciberKey(null);
        setRecordReviwerKey(null);
      }}
    />
  );

  const historianAccordion = (
    items: { title: React.ReactNode; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={historianKey}
      onSelect={(key) => setHistorianKey(key as string)}
    />
  );

  const recordReviewerAccordion = (
    items: { title: React.ReactNode; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={recordReviewerKey}
      onSelect={(key) => setRecordReviwerKey(key as string)}
    />
  );

  const editorAccordion = (
    items: { title: React.ReactNode; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={editorKey}
      onSelect={(key) => setEditorKey(key as string)}
    />
  );

  const transcriberAccordion = (
    items: { title: React.ReactNode; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={transciberKey}
      onSelect={(key) => setTransciberKey(key as string)}
    />
  );

  const handleInjuryChange = (selectedValues: any) => {
    setInjury(Array.isArray(selectedValues) ? selectedValues : []);
  };

  const handleAddressSuggestionSelect = async (suggestion: any) => {
    setIsManualLocation(false);
    setManualAddress(suggestion.providerAddress || "");
    setManualLocation(suggestion.providerName || "");
    const suggestedZip = suggestion.physicalZip || "";
    const newStateCode = normalizeState(suggestion.physicalState);
    const newCountryCode = normalizeCountry(suggestion.country || "USA");

    if (suggestion.physicalCity) setManualCity(suggestion.physicalCity);
    if (suggestion.physicalState) setManualState(newStateCode);
    if (suggestion.country) setManualCountry(newCountryCode);
    if (suggestion.physicalCity) setCityOptions([suggestion.physicalCity]);
    if (newStateCode) setStateOptions([newStateCode]);
    if (newCountryCode) setCountryOptions([newCountryCode]);

    if (suggestedZip) {
      setManualZip(suggestedZip);
      setZipOptions([suggestedZip]);

      try {
        const response = await searchManualZipCode({
          SearchString: suggestedZip,
          pageNo: 0,
          pageSize: 10,
          sortColumn: "",
          sortOrder: "",
        });

        const results = response?.result || [];

        if (results.length > 0) {
          const typedResults = results as HospitalClinicSearchResult[];
          const cities = [
            ...new Set(typedResults.map((r) => r.physicalCity).filter(Boolean)),
          ] as string[];
          const zips = [
            ...new Set(typedResults.map((r) => r.physicalZip).filter(Boolean)),
          ] as string[];
          const states = [
            ...new Set(
              typedResults.map((r) => r.physicalState).filter(Boolean),
            ),
          ] as string[];
          const countries = [
            ...new Set(typedResults.map((r) => r.country).filter(Boolean)),
          ] as string[];

          setCityOptions(cities);
          setZipOptions(zips);
          setStateOptions(states);
          setCountryOptions(countries);
        }
      } catch (error) {
        console.error("Zip lookup failed, using suggestion values:", error);
      }
    }
  };

  const handleManualLocationAdd = () => {
    setIsManualLocation(true);
    setManualLocation("");
    setManualAddress("");
    setManualCity("");
    setManualState("");
    setManualZip("");
    setManualCountry("");
  };

  const getPostHistorianDetails = async () => {
    try {
      const response = await getHistorianDetailsByQMEID(
        selectedRowData?.subjectQmeScheduleId,
      );
      const recordReviewerDataResponse = await GetReviewerRORStatusUpdateList(
        selectedRowData?.subjectQmeScheduleId,
      );
      const ediotrResponse = await getEditorDetailsByQMEID(
        selectedRowData?.subjectQmeScheduleId,
      );
      const transcriberResponse = await getTranscriberStatusLogsList(
        selectedRowData?.subjectQmeScheduleId,
      );
      const statusData = await getQMEProcessStatus(
        selectedRowData?.subjectQmeScheduleId,
      );
      if (response) {
        setHistorionData(response);
      }
      if (recordReviewerDataResponse) {
        setRecordReviewerData(recordReviewerDataResponse?.result || []);
      }

      if (ediotrResponse) {
        setEditorData(ediotrResponse || []);
      }
      if (transcriberResponse) {
        setTranscriberData(transcriberResponse?.result ?? []);
      }
      if (statusData) {
        setQMEProcessStatusData(statusData);
      }
    } catch (error) {
      console.error("Error fetching Histotian Details:", error);
    }
  };

  useEffect(() => {
    if (!dropdownOpen || !dropdownRef.current) return;

    const rect = dropdownRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const spaceBelow = viewportHeight - rect.bottom;
    const spaceAbove = rect.top;

    const DROPDOWN_HEIGHT = 260;

    if (spaceBelow < DROPDOWN_HEIGHT && spaceAbove > spaceBelow) {
      setOpenUpward(true);
    } else {
      setOpenUpward(false);
    }
  }, [dropdownOpen]);

  const [openUpward, setOpenUpward] = useState(false);
  // useEffect(() => {
  //   if (selectedRowData?.subjectQmeScheduleId) {
  //     getPostHistorianDetails();
  //   }
  // }, [selectedRowData?.subjectQmeScheduleId]);

  const selectedInjuryDetails = injury
    ?.map((value) => injuryOptions.find((opt) => opt.value === value))
    .filter(Boolean);

  const getHistorianStatusColor = (status: string) => {
    switch (status) {
      case HISTORY_REPORT_STATUS.NOT_SCHEDULED:
        return "#FF0000";
      case HISTORY_REPORT_STATUS.PENDING:
        return "#10a5ebff";
      case HISTORY_REPORT_STATUS.DRAFT:
        return "#fcaa13ff";
      case HISTORY_REPORT_STATUS.EXCEPTION:
        return "#fc7013ff";
      case HISTORY_REPORT_STATUS.COMPLETED:
        return "#0E8536";
      default:
        return "#000000";
    }
  };

  const getEditorStatusColor = (status: string) => {
    switch (status) {
      case EDITOR_REPORT_STATUS.OVERDUE:
      case EDITOR_REPORT_STATUS.EDITING_NOT_INITIATED:
        return "#FF0000";
      case EDITOR_REPORT_STATUS.APPROVED_BY_DOCTOR:
        return "#0092d5";
      case EDITOR_REPORT_STATUS.EDITING_PENDING:
        return "#197a72ff";
      case EDITOR_REPORT_STATUS.EDITING_IN_PROGRESS:
        return "#ffc117ff";
      case EDITOR_REPORT_STATUS.COMPLETED:
        return "#0E8536";
      case HISTORY_REPORT_STATUS.EXCEPTION:
        return "#fc7013ff";
      default:
        return "#000000";
    }
  };

  const getRORStatusColor = (status: string) => {
    switch (status) {
      case ROR_STATUS.NOT_INITIATED:
        return "#fa0808ff";
      case ROR_STATUS.IN_REVIEW:
        return "#0092d5";
      case ROR_STATUS.REVIEW_COMPLETED:
        return "#0E8536";
      case ROR_STATUS.DRAFT_REVIEW:
        return "#fcaa13ff";
      default:
        return "#000000";
    }
  };

  const getTranscriptionStatusColor = (status: string) => {
    switch (status) {
      case TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_NOT_INITIATED:
        return "#fa0808ff";
      case TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_COMPLETED:
        return "#0E8536";
      case TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_IN_PROGRESS:
        return "#fcaa13ff";
      case TRANSCRIPTION_REPORT_STATUS.EXCEPTION:
        return "#fc7013ff";
      case TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_PENDING:
        return "#197a72ff";
      default:
        return "#000000";
    }
  };

  type RoleType = "historian" | "ror" | "editor" | "transcription";

  const ROLE_CONFIG: Record<
    RoleType,
    {
      label: string;
      statusKey: string;
      assignedKey: string;
      createdKey: string;
      elapsedKey: string;
    }
  > = {
    historian: {
      label: "Historian",
      statusKey: "historianStatusName",
      assignedKey: "historianAssignedUserName",
      createdKey: "historianCreatedDate",
      elapsedKey: "historianElapsedDuration",
    },
    ror: {
      label: "Record Reviewer",
      statusKey: "rorStatusName",
      assignedKey: "rorAssignedUserName",
      createdKey: "rorCreatedDate",
      elapsedKey: "rorElapsedDuration",
    },
    editor: {
      label: "Editor",
      statusKey: "editorStatusName",
      assignedKey: "editorAssignedUserName",
      createdKey: "editorCreatedDate",
      elapsedKey: "editorElapsedDuration",
    },
    transcription: {
      label: "Transcriber",
      statusKey: "transcriberStatusName",
      assignedKey: "transcriberAssignedUserName",
      createdKey: "transcriberCreatedDate",
      elapsedKey: "transcriberElapsedDuration",
    },
  };

  const getStatusColorByRole = (role: RoleType, status: string): string => {
    switch (role) {
      case "historian":
        return getHistorianStatusColor(status);
      case "ror":
        return getRORStatusColor(status);
      case "editor":
        return getEditorStatusColor(status);
      case "transcription":
        return getTranscriptionStatusColor(status);
      default:
        return "#000000";
    }
  };

  const handleActionDrawer = () => {
    setShowViewScheduleDrawer(false);
    setShowViewScheduleSubmit(false);
  };

  const buildAccordionTitle = (
    role: RoleType,
    isOpen: boolean,
    data: any,
  ): React.ReactNode => {
    const cfg = ROLE_CONFIG[role];

    // If API returned null result
    if (!data) {
      return <span>{cfg.label}</span>;
    }

    const status = data?.[cfg.statusKey];
    const assigned = data?.[cfg.assignedKey];
    const created = data?.[cfg.createdKey];
    const elapsed = data?.[cfg.elapsedKey];

    const hasStatus = !!status;
    const hasAssigned = !!assigned;
    const hasCreated = !!created;
    const hasElapsed = !!elapsed;

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {/* LEFT: Always visible title */}
        <span>{cfg.label}</span>

        {/* RIGHT: Only when accordion is CLOSED and at least one value exists */}
        {(hasStatus || hasAssigned || hasCreated || hasElapsed) && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              whiteSpace: "nowrap",
              fontWeight: "normal",
            }}
          >
            {/* Status */}
            {hasStatus && (
              <span>
                <strong>Status :</strong>{" "}
                <span style={{ color: getStatusColorByRole(role, status) }}>
                  {status}
                </span>
              </span>
            )}

            {/* | between Status and Last Updated */}
            {hasStatus && hasCreated && (
              <span
                style={{ color: "#ccc", fontSize: "16px", lineHeight: "1.6" }}
              >
                |
              </span>
            )}

            {/* Last Updated On */}
            {hasCreated && (
              <span>
                <strong>Last Updated On :</strong> {created}
              </span>
            )}

            {/* | between Last Updated and Assigned */}
            {hasCreated && hasAssigned && (
              <span
                style={{ color: "#ccc", fontSize: "16px", lineHeight: "1.6" }}
              >
                |
              </span>
            )}

            {/* Assigned */}
            {hasAssigned && (
              <span style={{ color: "#0092d5" }}>By {assigned}</span>
            )}

            {/* | between (Last Updated OR Assigned) and Elapsed */}
            {(hasCreated || hasAssigned) && hasElapsed && (
              <span
                style={{ color: "#ccc", fontSize: "16px", lineHeight: "1.6" }}
              >
                |
              </span>
            )}

            {/* Elapsed Time */}
            {hasElapsed && (
              <span style={{ marginRight: "6px" }}>
                <strong>Elapsed Time :</strong> {elapsed}
              </span>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {!showViewScheduleDrawer ? (
        <Container fluid className="pb-5">
          <Loader isLoading={loading} />
          <Snackbar
            message={snackbarMessage}
            open={snackbarOpen}
            onClose={() => setSnackbarOpen(false)}
            severity={error}
          />

          <Row className="mt-3 align-items-center px-0 py-1 position-relative">
            <Col
              className="cancelappointment position-absolute"
              style={{
                float: "right",
                right: "0",
                top: "-52px",
                width: "32%",
                display: "flex",
                justifyContent: "end",
              }}
            >
              {/* {selectedRowData?.subjectQmeScheduleId &&
          !isActionButtonDisable &&
          showButton &&
          filteredActionOptionsNew?.length > 0 ? (
            <AppointmentActionsDropdown
              name="Actions"
              options={filteredActionOptionsNew}
              value={selectedAction}
              onChange={handleActionChange}
              disabled={isActionButtonDisable}
            /> */}
              {selectedRowData?.subjectQmeScheduleId &&
              filteredActionOptionsNew?.length > 0 ? (
                <AppointmentActionsDropdown
                  name="Actions"
                  options={filteredActionOptionsNew}
                  value={selectedAction}
                  onChange={handleActionChange}
                />
              ) : (
                ""
              )}
              {filteredViewSchedule && (
                <Button
                  className="d-flex align-items-center btn btn-primary mx-1 btn"
                  onClick={handleOpenDrawer}
                  disabled={!QMEDoctor}
                >
                  <span className="material-icons mr-2 mx-1">
                    calendar_month
                  </span>
                  View QME Schedule
                </Button>
              )}
              {filteredDoctorLocationMap && (
                <Button
                  variant="outline"
                  className="d-flex align-items-center btn-text-border p-1"
                  onClick={handleOpenNewTabForMap}
                  disabled={!QMEDoctor}
                >
                  <img src="/map.png" alt="map" />
                </Button>
              )}
            </Col>

            {scheduleAppointmentAccordion([
              {
                title: "Appointment Details",
                content: (
                  <>
                    <Row>
                      <Col sm={3}>
                        <FloatingLabelDatepicker
                          ref={datePickerRef}
                          label="Date Of Appointment"
                          name="dateOfAppointment"
                          value={dateOfAppointment}
                          onChange={(date: Date | null) => {
                            setDateOfAppointment(date);
                            setStartTime("");
                            setEndTime("");
                            setDuration(null);
                          }}
                          required
                          dateFormat="MM/dd/yyyy"
                          minDate={new Date()}
                          disabled={isDisableAction || view_Case}
                        />
                      </Col>
                      <Col>
                        <TimePicker
                          selectedTime={startTime}
                          onChange={handleStartTimeChange}
                          label="Start Time"
                          required
                          disabled={isDisableAction || view_Case}
                          date={dateOfAppointment}
                        />
                      </Col>
                      <Col>
                        <EndTimePicker
                          selectedTime={endTime}
                          onChange={setEndTime}
                          label="End Time"
                          required
                          disabled={
                            isDisableAction || view_Case || startTime == ""
                          }
                          date={dateOfAppointment}
                          startTime={startTime}
                        />
                      </Col>
                      <Col>
                        <TextInput
                          label="Duration"
                          name="duration"
                          value={duration}
                          onChange={(e) => {
                            setDuration(e.target.value);
                          }}
                          disabled
                        />
                      </Col>

                      <Col sm={4} className="selection_dropdown">
                        <SearchableSingleSelectDropdown
                          label="QME Doctor"
                          name="QMEDoctor"
                          required
                          options={QMEDoctorOptions}
                          value={QMEDoctor}
                          onChange={(e, name, value) => {
                            setQMEDoctor(value);
                            const selectedDoctor = QMEDoctorOptions?.find(
                              (doctor) => doctor.value === value,
                            );
                            if (selectedDoctor) {
                              const SpecilizationInfo = extractSpecialization(
                                selectedDoctor?.contactFullName,
                              );
                              setSpecialization(SpecilizationInfo || "");
                            }
                            fetchHospitalList(value);
                            validationCheck(value);
                            setIsValidateDate(false);
                            setSelectedOptionNew(null);
                            setClientResult({
                              employerName: "",
                              employerAddress: "",
                              employerCity: "",
                              employerState: "",
                              employerZipcode: "",
                              employerCountry: "",
                              employerContact: "",
                              empcontactemailaddress: "",
                              empcontactphonenumber: "",
                              empcontactfaxnumber: "",
                            });
                          }}
                          disabled={isDisableAction || view_Case}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      {medicalExamAccordion([
                        {
                          title: "Location Details",
                          content: (
                            <>
                              <Row>
                                <Col md={9} className="acssociated-location">
                                  <div
                                    className="form-floating"
                                    ref={dropdownRef}
                                    onClick={() =>
                                      setDropdownOpen(!dropdownOpen)
                                    }
                                    style={{ position: "relative" }}
                                  >
                                    <input
                                      type="text"
                                      name="QME Doctor Associated Location"
                                      className="form-control zipcodeDetailsOverlay"
                                      placeholder="QME Doctor Associated Location"
                                      maxLength={50}
                                      disabled={
                                        showAddClinic ||
                                        isDisableAction ||
                                        !QMEDoctor ||
                                        view_Case ||
                                        clinicDetails?.length === 0
                                      }
                                      value={
                                        selectedOptionNew
                                          ? selectedOptionNew.providerName
                                          : ""
                                      }
                                      autoComplete="off"
                                      readOnly
                                      required
                                    />
                                    <label>
                                      QME Doctor Associated Location
                                      <span style={{ color: "red" }}>*</span>
                                    </label>

                                    {/* Dropdown List */}
                                    {dropdownOpen &&
                                      clinicDetails.length > 0 && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            left: 0,
                                            right: 0,
                                            zIndex: 1050,
                                            background: "#fff",
                                            border: "1px solid #ccc",
                                            top: openUpward ? "auto" : "100%",
                                            bottom: openUpward
                                              ? "100%"
                                              : "auto",
                                          }}
                                        >
                                          <ul
                                            className="list-group"
                                            style={{
                                              maxHeight: "200px",
                                              overflowY: "auto",
                                            }}
                                          >
                                            {/* Header */}
                                            <li
                                              className="list-group-item d-flex justify-content-between align-items-center"
                                              style={{
                                                fontWeight: "bold",
                                                backgroundColor: "#f8f9fa",
                                              }}
                                            >
                                              <div style={{ width: "10%" }}>
                                                Select
                                              </div>
                                              <div style={{ width: "30%" }}>
                                                Location
                                              </div>
                                              <div style={{ width: "20%" }}>
                                                City
                                              </div>
                                              <div style={{ width: "20%" }}>
                                                State
                                              </div>
                                              <div style={{ width: "10%" }}>
                                                Country
                                              </div>
                                              <div style={{ width: "10%" }}>
                                                Zipcode
                                              </div>
                                            </li>

                                            {/* Options */}
                                            {clinicDetails.map((clinic) => (
                                              <li
                                                key={clinic.value}
                                                className={`list-group-item d-flex justify-content-between align-items-center ${
                                                  selectedOptionNew?.providerName ===
                                                  clinic.providerName
                                                    ? "selected-row"
                                                    : ""
                                                }`}
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                  handleSelectDropdown(clinic);
                                                }}
                                              >
                                                <div style={{ width: "10%" }}>
                                                  <input
                                                    type="radio"
                                                    name="location"
                                                    checked={
                                                      selectedOptionNew?.providerName ===
                                                      clinic.providerName
                                                    }
                                                    onChange={() =>
                                                      handleSelectDropdown(
                                                        clinic,
                                                      )
                                                    }
                                                  />
                                                </div>
                                                <div style={{ width: "30%" }}>
                                                  {clinic.providerName}
                                                </div>
                                                <div style={{ width: "20%" }}>
                                                  {clinic.physicalCity}
                                                </div>
                                                <div style={{ width: "20%" }}>
                                                  {clinic.physicalState}
                                                </div>
                                                <div style={{ width: "10%" }}>
                                                  {clinic.countryName}
                                                </div>
                                                <div style={{ width: "10%" }}>
                                                  {clinic.physicalZip}
                                                </div>
                                              </li>
                                            ))}
                                          </ul>
                                        </div>
                                      )}
                                  </div>
                                </Col>

                                <Col sm={3}>
                                  <div className="d-flex align-items-center mb-3 mt-3">
                                    <Form.Switch
                                      id="show-previous-contacts"
                                      label="Add Other Location"
                                      checked={showAddClinic}
                                      disabled={
                                        !QMEDoctor ||
                                        isDisableAction ||
                                        view_Case
                                      }
                                      onChange={() => {
                                        setShowAddClinic(!showAddClinic);
                                        setClinicId(null);
                                        setClientResult({
                                          employerName: "",
                                          employerAddress: "",
                                          employerCity: "",
                                          employerState: "",
                                          employerZipcode: "",
                                          employerCountry: "",
                                          employerContact: "",
                                          empcontactemailaddress: "",
                                          empcontactphonenumber: "",
                                          empcontactfaxnumber: "",
                                        });
                                        setSuggestionSelected(false);
                                        setSuggestionFilled({ city: false, state: false, country: false, zip: false });
                                        setAddressDetails({
                                          city: "",
                                          state: "",
                                          country: "",
                                          zip: "",
                                          medicareId: "",
                                          providerName: "",
                                          providerAddress: "",
                                        });
                                        setSelectedOptionNew(null);
                                        setSearchQuery("");
                                        setIsManualEntry(false);
                                        setManualLocation("");
                                        setManualAddress("");
                                        setManualCity("");
                                        setManualState("");
                                        setManualCountry("");
                                        setManualZip("");
                                        setCityOptions([]);
                                        setStateOptions([]);
                                        setCountryOptions([]);
                                        setZipOptions([]);
                                      }}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              {showAddClinic && (
                                <>
                                  {!isManualEntry && (
                                    <Row className="row mt-3">
                                      <Col md={12}>
                                        <SearchHospitalAutosuggest
                                          value={searchQuery}
                                          onChange={setSearchQuery}
                                          onSuggestionSelect={handleSuggestionSelect}
                                          onEnterNewLocation={handleEnterNewLocation}
                                          showEnterNewLocation={true}
                                          label="Location"
                                          required
                                          maxLength={50}
                                          disabled={isDisableAction || view_Case}
                                        />
                                      </Col>
                                    </Row>
                                  )}
                                  {isManualEntry ? (
                                    <Row className="row mb-3 mt-3">
                                      <Col md={12}>
                                        {!isManualLocation ? (
                                          <SearchAutosuggest
                                            value={manualLocation}
                                            onChange={setManualLocation}
                                            onSuggestionSelect={
                                              handleAddressSuggestionSelect
                                            }
                                            onManualLocationAdd={
                                              handleManualLocationAdd
                                            }
                                            enableManualLocation={true}
                                            label="Location"
                                            required
                                            apiKey={
                                              process.env
                                                .REACT_APP_GOOGLE_PLACES_AUTOCOMPLETE_API_KEY
                                            }
                                            countryRestriction="us"
                                            sortingLocation="Location"
                                            maxLength={100}
                                          />
                                        ) : (
                                          <TextInput
                                            label="Location"
                                            name="location"
                                            value={manualLocation}
                                            onChange={(e) =>
                                              setManualLocation(e.target.value)
                                            }
                                            maxLength={100}
                                            required
                                          />
                                        )}
                                      </Col>
                                    </Row>
                                  ) : null}
                                  <Row className="row mb-3 mt-3">
                                    {!isManualEntry ? (
                                      <Col md={12}>
                                        <TextInput
                                          label="Address Line 1"
                                          name="AddressLine1"
                                          value={addressDetails.providerAddress}
                                          disabled
                                          maxLength={100}
                                          required
                                        />
                                      </Col>
                                    ) : (
                                      <Col md={12}>
                                          <TextInput
                                            label="Address Line 1"
                                            name="AddressLine1"
                                            value={manualAddress}
                                            onChange={(e) =>
                                              setManualAddress(e.target.value)
                                            }
                                            maxLength={100}
                                            required
                                          />
                                      </Col>
                                    )}
                                  </Row>
                                  {!isManualEntry && (
                                    <Row className="row mb-3">
                                      {["City", "State", "Country", "Zip"].map(
                                        (field) => {
                                          const value =
                                            addressDetails[
                                              field.toLowerCase() as keyof typeof addressDetails
                                            ];

                                          const isDisabled = !suggestionSelected || !!suggestionFilled[field.toLowerCase() as keyof typeof suggestionFilled];
                                          return (
                                            <Col md={3} key={field}>
                                              <TextInput
                                                label={field}
                                                name={field}
                                                value={value}
                                                maxLength={field === "State" && !isDisabled ? 3 : field === "Zip" && !isDisabled ? 10 : 100}
                                                required
                                                onChange={(e) => {
                                                  const newValue = field === "Zip" ? e.target.value.replace(/\D/g, "") : e.target.value;
                                                  setAddressDetails((prev: any) => ({ ...prev, [field.toLowerCase()]: newValue }));
                                                }}
                                                disabled={isDisabled}
                                              />
                                            </Col>
                                          );
                                        },
                                      )}
                                    </Row>
                                  )}
                                  {isManualEntry && (
                                    <>
                                      <Row className="mb-3 mt-3 loc-details">
                                        <Col md={3}>
                                          <SearchableAddressDropdown
                                            label="City"
                                            value={manualCity}
                                            options={cityOptions}
                                            onSearch={handleSearch}
                                            onSelect={(val) =>
                                              setManualCity(val)
                                            }
                                            required={true}
                                            disabled={!isManualLocation}
                                          />
                                        </Col>
                                        <Col md={3}>
                                          <SearchableAddressDropdown
                                            label="State"
                                            value={manualState}
                                            options={stateOptions}
                                            onSearch={handleSearch}
                                            onSelect={(val) =>
                                              setManualState(val)
                                            }
                                            required={true}
                                            disabled={
                                              (!manualCity && !manualZip) ||
                                              stateOptions.length === 1 ||
                                              !isManualLocation
                                            }
                                          />
                                        </Col>
                                        <Col md={3}>
                                          <SearchableAddressDropdown
                                            label="Country"
                                            value={manualCountry}
                                            options={countryOptions}
                                            onSearch={handleSearch}
                                            onSelect={(val) =>
                                              setManualCountry(val)
                                            }
                                            required={true}
                                            disabled
                                          />
                                        </Col>
                                        <Col md={3}>
                                          <SearchableAddressDropdown
                                            label="Zip"
                                            value={manualZip}
                                            options={zipOptions}
                                            onSearch={handleSearch}
                                            onSelect={(val) =>
                                              setManualZip(val)
                                            }
                                            required={true}
                                            disabled={!isManualLocation}
                                          />
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                </>
                              )}

                              {clientResult?.employerName?.length > 0 && (
                                <>
                                  {clinicDetailFormAccordion([
                                    {
                                      title: "Contact Details",
                                      content: (
                                        <>
                                          <div>
                                            <Row>
                                              <Col
                                                sm={3}
                                                className="d-flex align-items-center py-2"
                                              >
                                                <span className="material-symbols-outlined mx-1 text-secondary">
                                                  home_health
                                                </span>
                                                Location
                                              </Col>
                                              <Col
                                                sm={3}
                                                className="d-flex align-items-center"
                                              >
                                                <span className="material-icons mx-1 text-secondary">
                                                  account_balance
                                                </span>
                                                Address
                                              </Col>
                                              <Col
                                                sm={6}
                                                className="d-flex align-items-center"
                                              >
                                                <span className="material-icons mx-1 text-secondary">
                                                  restart_alt
                                                </span>
                                                Communication Details
                                              </Col>
                                              <Col sm={12}>
                                                <EmployerDetailsCard
                                                  employerDetails={clientResult}
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                        </>
                                      ),
                                    },
                                  ])}
                                </>
                              )}
                              {showAddClinic && (
                                <>
                                  {addcomDetailAccordion([
                                    {
                                      title: "Additional Communication Details",
                                      content: (
                                        <>
                                          <Row>
                                            <Col sm={4}>
                                              <TagComponent
                                                label="Email Address"
                                                value={emailAddress}
                                                onChange={setEmailAddress}
                                                disabled={
                                                  isDisableAction || view_Case
                                                }
                                              />
                                            </Col>
                                            <Col sm={4}>
                                              <TagComponent
                                                label="Phone No"
                                                value={phoneNumber}
                                                onChange={(newValues) =>
                                                  setPhoneNumber(
                                                    newValues.map(String),
                                                  )
                                                }
                                                disabled={
                                                  isDisableAction || view_Case
                                                }
                                                isPhoneOrFax={true}
                                              />
                                            </Col>
                                            <Col sm={4}>
                                              <TagComponent
                                                label="Fax No"
                                                value={faxNumber}
                                                onChange={(newValues) =>
                                                  setFaxNumber(
                                                    newValues.map(String),
                                                  )
                                                }
                                                disabled={
                                                  isDisableAction || view_Case
                                                }
                                                isPhoneOrFax={true}
                                              />
                                            </Col>
                                          </Row>
                                        </>
                                      ),
                                    },
                                  ])}
                                </>
                              )}
                            </>
                          ),
                        },
                      ])}
                    </Row>
                    <Row className="mt-3">
                      <Col sm={3} className="selection_dropdown">
                        <SearchableSingleSelectDropdown
                          label="Exam Type"
                          name="type"
                          required
                          options={appointmentTypeOptions}
                          value={appointmentType}
                          onChange={(e, name, value) =>
                            setAppointmentType(value)
                          }
                          disabled={isDisableAction || view_Case}
                        />
                      </Col>
                      {/* <Col sm={3}>
                    <TextInput
                      label='Specialization'
                      name='specialization'
                      value={specialization}
                      onChange={(e) => {
                        setSpecialization(e.target.value);
                      }}
                      disabled
                    />
                  </Col> */}
                      <Col sm={3} className="selection_dropdown">
                        <SearchableSingleSelectDropdown
                          label="Medical Assistant"
                          name="medicalAssistant"
                          options={medicalAssistanceOptions}
                          value={medicalAssistance}
                          onChange={(e, name, value) =>
                            setMedicalAssistance(value)
                          }
                          disabled={isDisableAction || view_Case}
                        />
                      </Col>
                      <Col sm={3}>
                        <TextInput
                          label="Appointment Number"
                          name="appointmentNumber"
                          value={appointmentNumber}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            const validPattern = /^[A-Za-z0-9-/]*$/;

                            if (
                              inputValue?.length <= 15 &&
                              validPattern.test(inputValue)
                            ) {
                              setAppointmentNumber(inputValue);
                            }
                          }}
                          maxLength={15}
                          disabled={isDisableAction || view_Case}
                        />
                      </Col>
                      <Col sm={3} className="selection_dropdown">
                        <SearchableSingleSelectDropdown
                          label="Status"
                          name="status"
                          required
                          options={appointmentStatusOptions}
                          value={
                            appointmentStatus ||
                            appointmentStatusOptions?.find(
                              (item) => item.label === "Scheduled",
                            )?.value
                          }
                          onChange={(e, name, value) =>
                            setAppointmentStatus(value)
                          }
                          disabled
                          // disabled={
                          //   !selectedRowData?.subjectQmeScheduleId ||
                          //   isDisableAction ||
                          //   view_Case ||
                          //   isUpcommingOrlaterStatus
                          // }
                        />
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col sm={3}>
                        <div className="d-flex gap-3 mt-4">
                          <label className="me-2">
                            Medical Exam <span style={{ color: "red" }}>*</span>
                          </label>
                          {medicalExamOptions?.map((option) => (
                            <label key={option.value}>
                              <input
                                type="radio"
                                name="ismedicalExam"
                                value={option.value}
                                checked={ismedicalExam === option.value}
                                onChange={() => setIsMedicalExam(option.value)}
                                disabled={isDisableAction || view_Case}
                              />
                              <span className="ms-1">{option.label}</span>
                            </label>
                          ))}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col sm={12}>
                        <MultilineTextBox
                          label="Reason For Visit"
                          name="reasonForVisit"
                          value={reasonForVisit ?? ""}
                          onChange={(e) => {
                            let value = e.target.value;
                            if (value.startsWith(" ")) return;
                            value = value?.trimStart();
                            value = value.replace(/ {2,}/g, " ");
                            setReasonForVisit(value);
                          }}
                          maxLength={100}
                          disabled={isDisableAction || view_Case}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-0 mt-3">
                      <Col sm={3} className="d-flex align-items-center">
                        <div className="d-flex align-items-center gap-3">
                          <label className="me-2 fw-bold">
                            Interpreter Required{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>

                          <label className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="interpreterRequired"
                              checked={isInterpreterReq === true}
                              onChange={() => setIsInterpreterReq(true)}
                              className="me-1"
                              disabled={isDisableAction || view_Case}
                            />
                            Yes
                          </label>

                          <label className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="interpreterRequired"
                              checked={isInterpreterReq === false}
                              onChange={() => {
                                setIsInterpreterReq(false);
                                setVendor(null);
                                setLanguageNeed(null);
                                setShowAddInterpreter(false);
                                setSelectedOptionForInterpreter(null);
                                setInterpreterDetailsName("");
                                setInterpreterDetailsPhoneNo([]);
                                setInterpreterDetailsCertiNo("");
                                setSearchQueryForInterpreter("");
                              }}
                              className="me-1"
                              disabled={isDisableAction || view_Case}
                            />
                            No
                          </label>
                        </div>
                      </Col>
                      {isInterpreterReq === true ? (
                        <>
                          <Col sm={3} className="selection_dropdown">
                            <SearchableSingleSelectDropdown
                              label="Language Needs"
                              name="languageNeed"
                              required
                              options={languageNeedOptions}
                              value={languageNeed}
                              onChange={(e, name, value) => {
                                setLanguageNeed(value);
                                const selectedOption = languageNeedOptions.find(
                                  (option) => option.value === value,
                                );
                                setLanguageNeedLabel(
                                  selectedOption?.label || "",
                                );
                              }}
                              disabled={isDisableAction || view_Case}
                            />
                          </Col>
                          {/* <Col sm={3} className="selection_dropdown">
                        <SearchableSingleSelectDropdown
                          label="Vendor"
                          name="vendor"
                          required
                          options={vendorOptions}
                          value={vendor}
                          onChange={(e, name, value) => setVendor(value)}
                          disabled={isDisableAction || view_Case}
                        />
                      </Col> */}
                        </>
                      ) : (
                        ""
                      )}
                    </Row>
                    {isInterpreterReq && (
                      <Row className="mb-0 mt-3">
                        <>
                          {interpreterDetailAccordion([
                            {
                              title: "Interpreter Details",
                              content: (
                                <>
                                  <Row>
                                    <Col md={9}>
                                      <div
                                        className="form-floating"
                                        ref={dropdownRef}
                                      >
                                        <input
                                          type="text"
                                          name="Enter Interpreter Name"
                                          className="form-control zipcodeDetailsOverlay"
                                          placeholder="Enter Interpreter Name"
                                          maxLength={50}
                                          disabled={
                                            showAddInterpreter ||
                                            isDisableAction ||
                                            view_Case
                                          }
                                          value={searchQueryForInterpreter}
                                          onChange={
                                            handleSearchChangeForInterpreter
                                          }
                                          autoComplete="off"
                                          required
                                        />
                                        <label>
                                          Enter Interpreter Name
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>

                                        {filteredResultsForInterpreter.length >
                                          0 && (
                                          <div className="dropdown-results">
                                            <ul
                                              className="list-group"
                                              style={{
                                                maxHeight: "200px",
                                                overflowY: "auto",
                                              }}
                                            >
                                              {/* Header */}
                                              <li
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                                style={{
                                                  fontWeight: "bold",
                                                  backgroundColor: "#f8f9fa",
                                                }}
                                              >
                                                <div style={{ width: "10%" }}>
                                                  Select
                                                </div>
                                                <div style={{ width: "30%" }}>
                                                  Interpreter Name
                                                </div>
                                                <div style={{ width: "20%" }}>
                                                  Phone Number
                                                </div>
                                                <div style={{ width: "20%" }}>
                                                  Certificate Number
                                                </div>
                                              </li>

                                              {filteredResultsForInterpreter.map(
                                                (option) => (
                                                  <li
                                                    key={option.interpreterName}
                                                    className="list-group-item d-flex justify-content-between align-items-center"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      handleSelectInterpreterDropdown(
                                                        option,
                                                      )
                                                    }
                                                  >
                                                    <div
                                                      style={{ width: "10%" }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        name="location"
                                                        checked={
                                                          selectedOptionForInterpreter?.interpreterName ===
                                                          option.interpreterName
                                                        }
                                                        onChange={() =>
                                                          handleSelectInterpreterDropdown(
                                                            option,
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                    <div
                                                      style={{ width: "30%" }}
                                                    >
                                                      {option.interpreterName}
                                                    </div>
                                                    <div
                                                      style={{ width: "20%" }}
                                                    >
                                                      {
                                                        option.interpreterPhoneNumber
                                                      }
                                                    </div>
                                                    <div
                                                      style={{ width: "20%" }}
                                                    >
                                                      {
                                                        option.interpreterCertificateNumber
                                                      }
                                                    </div>
                                                  </li>
                                                ),
                                              )}
                                            </ul>
                                          </div>
                                        )}
                                      </div>
                                    </Col>

                                    <Col sm={3}>
                                      <div className="d-flex align-items-center mb-3 mt-3">
                                        <Form.Switch
                                          id="show-previous-contacts"
                                          label="Add Interpreter"
                                          checked={showAddInterpreter}
                                          disabled={
                                            isDisableAction || view_Case
                                          }
                                          onChange={() => {
                                            setShowAddInterpreter(
                                              !showAddInterpreter,
                                            );
                                            setIsShowInterpreter(
                                              !showAddInterpreter,
                                            );
                                            setFilteredResultsForInterpreter(
                                              [],
                                            );
                                            setSelectedOptionForInterpreter(
                                              null,
                                            );
                                            setInterpreterDetailsName("");
                                            setInterpreterDetailsPhoneNo([]);
                                            setInterpreterDetailsCertiNo("");
                                            setSearchQueryForInterpreter("");
                                          }}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  {isshowInterpreter && (
                                    <Row>
                                      <Col sm={3}>
                                        <TextInput
                                          label="Interpreter Name"
                                          value={interpreterDetailsName}
                                          onChange={(e) => {
                                            let value = e.target.value;
                                            if (value.startsWith(" ")) return;
                                            value = value.replace(
                                              /\s{2,}/g,
                                              " ",
                                            );
                                            setInterpreterDetailsName(value);
                                          }}
                                          disabled={
                                            isDisableAction || view_Case
                                          }
                                          maxLength={100}
                                          required
                                        />
                                      </Col>
                                      <Col sm={6}>
                                        <TagComponent
                                          label="Phone Number"
                                          value={interpreterDetailsPhoneNo}
                                          onChange={(newValues) =>
                                            setInterpreterDetailsPhoneNo(
                                              newValues.map(String),
                                            )
                                          }
                                          disabled={
                                            isDisableAction || view_Case
                                          }
                                          isPhoneOrFax={true}
                                          required
                                        />
                                      </Col>
                                      <Col sm={3}>
                                        <TextInput
                                          label="Certificate Number"
                                          value={interpreterDetailsCertiNo}
                                          onChange={(e) => {
                                            let value = e.target.value;
                                            if (value.startsWith(" ")) return;
                                            value = value.replace(
                                              /\s{2,}/g,
                                              " ",
                                            );
                                            const validPattern =
                                              /^[A-Za-z0-9-/]*$/;
                                            if (validPattern.test(value)) {
                                              setInterpreterDetailsCertiNo(
                                                value,
                                              );
                                            }
                                          }}
                                          disabled={
                                            isDisableAction || view_Case
                                          }
                                          maxLength={20}
                                          required
                                        />
                                      </Col>
                                    </Row>
                                  )}
                                </>
                              ),
                            },
                          ])}
                        </>
                      </Row>
                    )}
                    <Row className="mb-0 mt-3">
                      <>
                        {injuryDetailAccordion([
                          {
                            title: "Injury Details",
                            content: (
                              <>
                                <Row>
                                  <Col sm={3} className="selection_dropdown">
                                    <SearchableMultiSelectDropdown
                                      label="Injury"
                                      name="injury"
                                      options={injuryOptions}
                                      values={injury}
                                      onChange={(e, name, selectedValues) =>
                                        handleInjuryChange(selectedValues)
                                      }
                                      required
                                      disabled={isDisableAction || view_Case}
                                    />
                                  </Col>
                                  {injury &&
                                    selectedInjuryDetails?.map((inj, index) => (
                                      <Col
                                        key={index}
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={3}
                                        className="record_listbox fade-in-left"
                                      >
                                        <Card className="h-100 shadow-sm border-0 card_rec">
                                          <Card.Body className="p-0 rec_data_listaa">
                                            <div className="d-flex p-2">
                                              <span className="title_tt">
                                                Injury Type
                                              </span>
                                              <TextWithTooltip
                                                text={String(inj?.injuryType)}
                                                className="rec_output"
                                              />
                                            </div>
                                            <div className="d-flex p-2">
                                              <span className="title_tt">
                                                Claim No
                                              </span>
                                              <TextWithTooltip
                                                text={String(inj?.claimNo)}
                                                className="rec_output rec_output"
                                              />
                                            </div>
                                            <div className="d-flex p-2">
                                              <span className="title_tt">
                                                Date of Incident
                                              </span>
                                              <TextWithTooltip
                                                text={String(
                                                  inj?.dateOfIncident,
                                                )}
                                                className="rec_output rec_output"
                                              />
                                            </div>
                                            <div className="d-flex p-2">
                                              <span className="title_tt">
                                                Insurance Carrier
                                              </span>
                                              <TextWithTooltip
                                                text={String(
                                                  inj?.insuranceCarrier,
                                                )}
                                                className="rec_output rec_output"
                                              />
                                            </div>
                                          </Card.Body>
                                        </Card>
                                      </Col>
                                    ))}
                                </Row>
                              </>
                            ),
                          },
                        ])}
                      </>
                    </Row>
                  </>
                ),
              },
            ])}
          </Row>

          {selectedRowData !== null
            ? postQMEAccordion([
                {
                  title: "Pre / Post QME Information",
                  content: (
                    <>
                      {historianAccordion([
                        {
                          title: buildAccordionTitle(
                            "historian",
                            Boolean(historianKey),
                            qmeProcessStatusData,
                          ),
                          content: (
                            <>
                              <DataTable
                                headers={QME_HISTORIAN_HEADERS}
                                rows={historionData}
                              />
                            </>
                          ),
                        },
                      ])}
                      {recordReviewerAccordion([
                        {
                          title: buildAccordionTitle(
                            "ror",
                            Boolean(recordReviewerKey),
                            qmeProcessStatusData,
                          ),
                          content: (
                            <>
                              <DataTable
                                headers={REVIEW_HISTORY_HEADERS}
                                rows={recordReviewerData}
                              />
                            </>
                          ),
                        },
                      ])}
                      {transcriberAccordion([
                        {
                          title: buildAccordionTitle(
                            "transcription",
                            Boolean(transciberKey),
                            qmeProcessStatusData,
                          ),
                          content: (
                            <>
                              <DataTable
                                headers={TRANSC_EDITOR_HEADERS}
                                rows={transcriberData}
                              />
                            </>
                          ),
                        },
                      ])}
                      {editorAccordion([
                        {
                          title: buildAccordionTitle(
                            "editor",
                            Boolean(editorKey),
                            qmeProcessStatusData,
                          ),
                          content: (
                            <>
                              <DataTable
                                headers={QME_EDITOR_HEADERS}
                                rows={editorData}
                              />
                            </>
                          ),
                        },
                      ])}
                    </>
                  ),
                },
              ])
            : ""}

          <Row className="mb-3 mt-3">
            <Col className="d-flex justify-content-start">
              {userData?.caseInfoId ? (
                <Button
                  variant="outline"
                  className="d-flex align-items-center btn-text-border me-1"
                  onClick={handleBack}
                >
                  <span className="material-icons mr-2 ">arrow_back</span>
                  Back
                </Button>
              ) : (
                ""
              )}

              {selectedRowData !== null &&
              selectedRowData.status != "Cancelled" ? (
                <Button
                  type="submit"
                  variant="primary"
                  className="d-flex align-items-center mx-2"
                  disabled={!is110Download}
                  onClick={() => download110Form()}
                >
                  <span className="material-icons mx-1">picture_as_pdf</span>{" "}
                  Generate 110/SIBTF Form
                </Button>
              ) : (
                ""
              )}
            </Col>

            <Col className="d-flex justify-content-end">
              <Button
                variant="outline-info"
                className="d-flex align-items-center"
                onClick={handleCancelButton}
                disabled={!hasChanges() || isDisableAction || view_Case}
              >
                <span className="material-icons mr-2">close</span> Cancel
              </Button>
              {isEditable ? (
                <Button
                  type="submit"
                  variant="primary"
                  className="d-flex align-items-center ml-2"
                  onClick={handleSubmit}
                  disabled={
                    isStageNonEditable ||
                    view_Case ||
                    (isRowActionTriggered
                      ? !hasChanges() || isDisableAction || isValidateDate
                      : false)
                  }
                >
                  <span className="material-icons mx-1">save</span> Save
                </Button>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Body className="fw-bold text-left modelheading">
              <div className="mb-2">Do you want to Cancel Appointment?</div>
              <div className="form-group">
                <label htmlFor="cancelReason" className="form-label fw-normal">
                  Reason for Cancellation <span className="text-danger">*</span>
                </label>
                <textarea
                  id="cancelReason"
                  className="form-control"
                  rows={3}
                  value={cancelReason}
                  onChange={(e) => setCancelReason(e.target.value)}
                  placeholder="Enter reason here..."
                />
              </div>
            </Modal.Body>
            <Modal.Footer className="border-0 d-flex justify-content-end">
              <Button
                variant="outline-info"
                className="d-flex align-items-center"
                onClick={handleCloseModal}
              >
                <span className="material-icons mr-2">close</span> Cancel
              </Button>
              <Button
                variant="primary"
                className="ms-3 d-flex align-items-center"
                onClick={handleConfirmCancel}
                disabled={!cancelReason.trim()}
              >
                <span className="material-icons mx-1">check</span> Confirm
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={showModalNew} onHide={handleCloseModalNew}>
            <Modal.Body className="fw-bold text-left modelheading ">
              <div>Are you sure you want to cancel?</div>
            </Modal.Body>
            <Modal.Footer className="border-top d-flex justify-content-end">
              <Button
                variant="outline-info"
                className="d-flex align-items-end"
                onClick={handleCloseModalNew}
              >
                <span className="material-icons mr-2">close</span> Cancel
              </Button>
              <Button
                onClick={handleConfirmCancelButton}
                variant="primary"
                className="ms-3 d-flex align-items-center"
              >
                <span className="material-icons mx-1">check</span> Confirm
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={showModalForAction}
            onHide={handleCloseModalForAction}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="recordList"
          >
            <Modal.Header closeButton className="d-flex">
              <Modal.Title className="fw-bold text-left modelheading offcanvas-title d-flex align-items-center">
                Appointment Action —{" "}
                <span className="ms-2">{selectedActionlabel}</span>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="fw-bold text-left modelheading ">
              <>
                {selectedAction === QME_APPOINTMENT_STATUS.RESCHEDULED ||
                selectedAction ===
                  QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE ? (
                  <>
                    <div className="text-warning fs-13 my-2">
                      1. Appointment(s) during this time span will be
                      Reschedule!
                    </div>
                    {mediacreLocation && (
                      <>
                        <div className="text-muted mt-2 fs-13">Location</div>
                        <Row className="mt-1 mb-3">
                          <Col sm={12}>
                            <TextInput
                              label={"Location"}
                              name={"location"}
                              value={locationForAction}
                              disabled
                            />
                          </Col>
                        </Row>
                      </>
                    )}
                    <div className="text-muted mt-1 fs-13">Date & Time</div>
                    <Row className="mt-1 mb-3">
                      <Col sm={5}>
                        <FloatingLabelDatepicker
                          ref={datePickerRef}
                          label="Date"
                          name="date"
                          value={dateForAction}
                          onChange={(date: Date | null) => {
                            setDateForAction(date);
                          }}
                          dateFormat="MM/dd/yyyy"
                          minDate={new Date()}
                          required
                        />
                      </Col>
                      <Col sm={5}>
                        <TimePicker
                          selectedTime={startTimeForAction}
                          onChange={handleStartTimeChangeForAction}
                          label="Time"
                          required
                          date={dateForAction}
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}
                <div className="text-muted mt-1 fs-13">
                  Please specify reason for{" "}
                  {selectedAction === "Cancelled"
                    ? "cancellation"
                    : selectedActionlabel}
                </div>
                <Row className="mt-1">
                  <Col sm={12} className="notemultiline">
                    <MultilineTextBox
                      label="Reason"
                      name="reason"
                      value={reasonForAction ?? ""}
                      onChange={(e) => {
                        let value = e.target.value;
                        if (value.startsWith(" ")) return;
                        value = value?.trimStart();
                        value = value.replace(/ {2,}/g, " ");
                        setReasonForAction(value);
                      }}
                      maxLength={100}
                    />
                  </Col>
                </Row>
              </>
            </Modal.Body>
            <Modal.Footer className="border-top d-flex justify-content-end">
              <Button
                variant="outline-info"
                className="d-flex align-items-end"
                onClick={handleCloseModalForAction}
              >
                <span className="material-icons mr-2">close</span> Cancel
              </Button>
              <Button
                onClick={handleConfirmActionButton}
                variant="primary"
                className="ms-3 d-flex align-items-center"
              >
                <span className="material-icons mx-1">save</span> Save
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      ) : (
        <ViewQMESchedule
          doctorInfo={selectedDoctorInfo}
          onCancel={handleCalenderViewBack}
        />
      )}
    </>
  );
};
export default ScheduleAppointment;
